import React, { useState, useEffect, useRef } from "react";
import { Button, Grid, TextField, Typography, Box, Modal,Checkbox, FormControlLabel, } from "@mui/material";
import axios from "axios";
import { Container } from "reactstrap";
import { Controller, useForm } from "react-hook-form";
import { useAlert } from "react-alert";
import { useNavigate } from "react-router-dom";
import ClickAwayListener from '@mui/material/ClickAwayListener';
import PrintIcon from '@mui/icons-material/Print';
import { useReactToPrint } from 'react-to-print'
import Headroom from "react-headroom";
import DialogTitle from '@mui/material/DialogTitle';
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import { yupResolver } from '@hookform/resolvers/yup'
import * as Yup from 'yup'
import Moment from 'moment'
import Select from "react-select";
import SearchIcon from '@mui/icons-material/Search'
import { ToastContainer, toast } from 'react-toastify';
import ReactSelect from "react-select";
import 'react-toastify/dist/ReactToastify.css';
//Import Breadcrumb
import "./Button.css"
import TextareaAutosize from '@mui/material/TextareaAutosize';
import InputMask from 'react-input-mask';
import CircularProgress from "@mui/material/CircularProgress";
import PatientRegistration from "./PatientRegistration";
import { useSelector } from "react-redux";

// const history = useHistory(); 
const Prior_auth = (props) => {
  const rights = useSelector((state) => state.login.rights);

  const [Formdid, setFormdid] = useState(props.formDid !== undefined ? props.formDid : 0)
  const [columnID, setcolumnID] = useState(props.columnID > 0 ? props.columnID : props.columnIDcpt)
  const [Formdid1, setFormdid1] = useState(props.formDid !== undefined ? props.formDid : 0)
  const [columnID1, setcolumnID1] = useState(props.columnID !== undefined ? props.columnID : 0)
  const [columnIDcpt, setcolumnIDcpt] = useState(props.columnID > 0 ? props.columnID : props.columnIDcpt)
  const [Formdidcpt, setFormdidcpt] = useState(props.columnIDcpt !== undefined ? props.columnIDcpt : 0)

  // const patientId = props.patientid;
  const patientId = (props.callingFrom == "update" ? props.patientid : props.patientid)
  const patientNameee = props.patientNameee;
  const PpatientName = props.patientName;
  const PatientIdOfdemographics = props.PatientIdOfdemographics
  const [patientName, setpatientName] = useState(props.patientNameee);

  const [patName, setPatName] = useState(
    patientName || props.patientName || props.patientNameee || ""
  );


  const [Markaporoved, setMarkaporoved] = useState(props.Markaporoved);
  const [AutpattientID, setAutpattientID] = useState(props.AutpattientID1 || props.patientID)
  const [authid, setAuthId] = useState()
  const [patId, setPatId] = useState();
  const [cellPhone, setcellPhone] = React.useState()

  const [dob, setDOB] = React.useState(Moment().format('YYYY-MM-DD'),)
  const DOB = props.callingFrom == "Pateint" ? props.DOB : dob;
  const [patQuestion, setPatQuestion] = useState();
  const [insuDate, setInsuDate] = React.useState(Moment().format('YYYY-MM-DD'))
  const [rangeDate, setRangeDate] = React.useState('')
  const [rangeDateform, setRangeDateform] = React.useState('')

  const [induDeduct, setInduDeduct] = useState();
  const [rangecomments, setrangecomments] = useState('');

  const [backofficecomment, setbackofficecomment] = useState('');



  const [induAmou, setInduAmou] = useState();
  const [remaDeduct, setRemaDeduct] = useState();
  const [famDeduct, setFamDeduct] = useState();
  const [famAmount, setFamAmount] = useState();
  const [primaryInsurance, setprimaryInsurance] = useState();


  const [insuName, setInsuName] = useState();
  const [polName, setPolName] = useState();
  const [phoneNumber, setPhoneNumber] = useState();
  const [repName, setRepName] = useState();
  const [contract, setContract] = useState();
  const [addNotes, setAddNotes] = useState();
  const [inNetwork, setInNetwork] = useState();
  const [outNetwork, setOutNetwork] = useState();
  const [contractYear, setContractYear] = useState();
  const [cellReference, setCellReference] = useState();
  const [approval, setApproval] = useState();
  const [cpap, setcpap] = useState();
  const [appliance, setappliance] = useState();

  const [GAP, setGAP] = useState();


  const [pAuthNmbr, setPAuthNmbr] = useState();
  const [pInsurance, setPInsurance] = useState(true);
  const [estimatedAllowable, setestimatedAllowable] = useState();
  const [totalEstimated, settotalEstimated] = useState();


  const [apDentist, setApDentist] = useState();
  const [pauthTreatment, setPauthTreatment] = useState();
  const [ApprovedAppliance, setApprovedAppliance] = useState("");
  const [errorApprovedAppliance, setErrorApprovedAppliance] = useState('');

const UserType = localStorage.getItem('User_Type')

// Validation function
const validateForm = () => {
  let isValid = true;
    if (!ApprovedAppliance) {
      setErrorApprovedAppliance('Please select Approved Appliance');
      isValid = false;
    } else {
      setErrorApprovedAppliance('');
    }

  return isValid;
}
  const [coInsu, setCoInsu] = useState();
  const [coInsuRespon, setCoInsuRespon] = useState();
  const [inactive, setInactive] = useState();
  const [ccyear, setCalendarYear] = useState();
  const [practiceId, setPracticeId] = useState();
  const [createdBy, setCreatedBy] = useState();
  const [createdDate, setCreatedDate] = React.useState(Moment().format('YYYY-MM-DD'))
  const [cellDate, setCellDate] = React.useState(Moment().format('YYYY-MM-DD'))
  const [updatedBy, setUpdatedBy] = useState();
  const [updatedDate, setUpdatedDate] = React.useState(Moment().format('YYYY-MM-DD'))
  const [ccDate, setCcDate] = React.useState(Moment().format('YYYY-MM-DD'))
  const [cuDate, setCUDate] = React.useState(Moment().format('YYYY-MM-DD'))
  const [provname, setProvName] = useState("")
  // const [suggestions, setSuggestions] = useState([]);
  // const [selectedProvider, setSelectedProvider] = useState(null);
  const [openInsurances, setOpenInsurances] = useState(false)
  const [insuranceNames, setInsuranceNames] = React.useState([])

  const [fetchedData, setfetchedData] = useState(false)
  const [loadingTime, setloadingTime] = useState(0)
  const [disable, setdisable] = React.useState(false)
  const [patientdob, setpatientdob] = React.useState(Moment().format('YYYY-MM-DD'),)

  const [patientinsurancename, setpatientinsurancename] = useState("");
  const [Secondaryinsurancename, setSecondaryinsurancename] = useState("");
  const [patientdiercttname, setpatientdiercttname] = useState("");

  const [patientphone, setpatientphone] = useState("");
  const [SecondaryPatientPhone, setSecondaryPatientPhone] = useState("");
  const [Secondarymemberid, setSecondarymemberid] = useState("");
  const [memberid, setmemeberid] = useState('');
  const [payerID, setpayerID] = useState('');
  const [SecondarypayerID, setSecondarypayerID] = useState('');
  const [codevob, setCodevob] = useState('')
  const [prodiceridvob, setProdiceridvob] = useState('')
  const [priorAuthRequestFormId, setPriorAuthRequestFormId] = useState(0)
  const [taxId, setTaxId] = useState("");
  const [npi, setNpi] = useState("");
  const [referringProvider, setReferringProvider] = useState("");
  const [referringProviderNpi, setReferringProviderNpi] = useState("");
  const [degvob, setdegdvob] = useState(null)
  const [submitting, setSubmitting] = useState(false);
  const [isLoading, setLoading] = useState(false)
  const alert = useAlert();
  const practiceID = localStorage.getItem('default_paractice')
  const [providers, setProviders] = useState([]);
  const [providersid, setProvidersid] = useState([]);

  const [printpage, setPrintPage] = useState(false);
  const printRef1 = useRef();
  const [procedureCode1ID, setProcedureCode1ID] = useState("");
  const [procedureCode1List, setProcedureCode1List] = useState([]);
  const [diagnosisID, setDiagnosisID] = useState("");
  const [diagnosisList, setDiagnosisList] = useState([]);

  const fields = [
    "id",
    "patientId",
    "providerId",
    "patientName",
    "dob",
    "providerName",
    "insuranceEffectiveDate",
    "rangeDate",
    "individualDeductible",
    "individualAmountMet",
    "remainingDeductible",
    "familyDeductible",
    "familyAmountMet",
    "insuranceName",
    "policyNumber",
    "phoneNumber",
    "representativeName",
    "contract",
    "additionalNotes",
    "inNetwork",
    "outNetwork",
    "contractYear",
    "calenderYear",
    "cellReference",
    "approval",
    "preAuthorizationNumber",
    "primaryInsurance",
    "approvedDentist",
    "preAuthorizationTreatment",
    "coInsurancePercAllowable",
    "coInsurancePercPatRespon",
    "inactive",
    "practiceId",
    "createdBy",
    "createdDate",
    "cellDate",
    "updatedBy",
    "updatedDate",
    "clientCreatedDate",
    "clientUpdatedDate",
    "rangeDateform",
    "rangecomments",
    "procedureCode",
    "diagnosisCode",
    "estimatedAllowable",
    "totalEstimated",
    "memberId",
    "npi",
    "taxId",
    "referringProvider",
    "dateSubmission",
    "referringProviderNpi",
    "archived",
       "primaryInsurance_Name",
    "primaryInsurance_MemberId",
    "primaryInsurance_PayerId",
    "secondaryInsurance_Name",
    "secondaryInsurance_MemberId",
    "secondaryInsurance_PayerId",
    "approvedAppliance"

  ];
  const defValues = {
    id: 0,
    patientName: "",
    patientId: "",
    providerId: "",
    memberId: 0,
    dob: "",
    providerName: "",
    insuranceEffectiveDate: "",
    rangeDate: "",
    individualDeductible: "",
    individualAmountMet: "",
    remainingDeductible: "",
    familyDeductible: "",
    familyAmountMet: "",
    insuranceName: "",
    policyNumber: "",
    phoneNumber: "",
    representativeName: "",
    contract: "",
    additionalNotes: "",
    inNetwork: "",
    outNetwork: "",
    contractYear: "",
    calenderYear: "",
    cellReference: "",
    approval: null,
    preAuthorizationNumber: "",
    primaryInsurance: true,
    approvedDentist: "",
    preAuthorizationTreatment: "",
    coInsurancePercAllowable: null,
    coInsurancePercPatRespon: null,
    inactive: "",
    practiceId: 0,
    createdBy: "",
    createdDate: "",
    cellDate: "",
    updatedBy: "",
    updatedDate: "",
    clientCreatedDate: "",
    clientUpdatedDate: "",
    rangeDateform: "",
    rangecomments: "",
    procedureCode: "",
    diagnosisCode: "",
    estimatedAllowable: "",
    totalEstimated: "",
    taxId: "",
    npi: "",
    referringProvider: "",
    referringProviderNpi: "",
    dateSubmission: '',
    archived: null,
    primaryInsurance_Name:"",
    primaryInsurance_MemberId:"",
    primaryInsurance_PayerId:"",
    secondaryInsurance_Name:"",
    secondaryInsurance_MemberId:"",
    secondaryInsurance_PayerId:"",
    approvedAppliance:"",
  };

  // document.title = "Prior Auth & VOB | LuxBillingEHR";
  // API Authanticatiion
  const token = localStorage.getItem('Token')
  const auth = `Bearer ${token}`
  const headers = {
    Authorization: auth
  }
  const navigate = useNavigate();
  const [refresh, setRefresh] = useState(false);


  const [zipCodeList, setZipCodeList] = React.useState([])
  //   const validationSchema = Yup.object({
  //     // individualDeductible: Yup.string()
  //     // .matches(/^\d*\.?\d*$/, 'Only digits are allowed')
  //     // .required('Deductible is required'),
  //     // individualAmountMet: Yup.string()
  //     // .matches(/^\d*\.?\d*$/, 'Only digits are allowed')
  //     // .required('Field is required'),
  //     // familyDeductible: Yup.string()
  //     // .required('Field is required'),
  //     // familyAmountMet: Yup.string()
  //     // .required('Field is required'),
  //     // remainingDeductible: Yup.string()
  //     // .matches(/^\d*\.?\d*$/, 'Only digits are allowed')
  //     // .required('Field is required'),
  //     // approval: Yup.string()
  //     // .matches(/^\d*\.?\d*$/, 'Only digits are allowed')
  //     // .required('Field is required'),
  //     // estimatedAllowable: Yup.string()
  //     // .matches(/^\d*\.?\d*$/, 'Only digits are allowed')
  //     // .required('Field is required'),
  //     // totalEstimated: Yup.string()
  //     // .matches(/^\d*\.?\d*$/, 'Only digits are allowed')
  //     // .required('Field is required'),

  // })
  const {
    register,
    control,
    handleSubmit,
    getValues,
    setValue,
    formState: { errors },
  } = useForm({
    mode: "onBlur",
    reValidateMode: "onChange",
    context: undefined,
    criteriaMode: "firstError",
    shouldFocusError: true,
    shouldUnregister: false,
    shouldUseNativeValidation: false,
    delayError: undefined,
    defaultValues: defValues,
    // resolver: yupResolver(validationSchema),

  });







  // useEffect(() => {
  //   axios
  //     .get(
  //       `${process.env.REACT_APP_API_URL}/Patients/SearchInsuranceName?patientId=${AutpattientID}`,
  //       {
  //         headers,
  //       }
  //     )
  //     .then((response) => {
  //       const Data = response[0]
  //       var dateYMD = Moment(Data.dob).format('YYYY-MM-DD')
  //       setDOB(dateYMD)
  //       setpatientdiercttname(Data.patientName)
  //       setpatientinsurancename(Data.planName)
  //       setpatientphone(Data.phoneNumber)
  //       setmemeberid(Data.memberId)
  //       setpayerID(Data.payerId)
  //       const SecondaryData = response[1]
  //       setSecondarymemberid(SecondaryData.memberId)
  //       setSecondaryPatientPhone(SecondaryData.phoneNumber)
  //       setSecondaryinsurancename(SecondaryData.planName)
  //       setSecondarypayerID(SecondaryData.payerId)


  //     })

  //     .catch((error) => {
  //       console.error("There was an error!", error);
  //     });
  // }, [AutpattientID]);
  useEffect(() => {
    // if(columnIDcpt>0)
    // {
    //   axios
    //   .get(
    //     `${process.env.REACT_APP_API_URL}/PatientNote/AuthorizationFormByCPTById?Id=${columnIDcpt}&authId=${columnIDcpt}`,
    //     { headers }
    //   )
    //   .then(response => {
    //     console.log('response.dataaaaa: ', response.address
    //     )
    //     // fields.forEach(field => {
    //     //   setValue(field, response[field])
    //     // })
    //     setCodevob(response.cptcode)
    //     setdegdvob(response.iCD)
    //     setProdiceridvob(response.providerId)
    //     // setFormDataId(response.formId)

    //   })

    //   .catch(error => {
    //     console.error('There was an error!', error)
    //   })
    // }
    axios
      .get(
        `${process.env.REACT_APP_API_URL}/AutherizationRequest/PriorAuthRequestByFormId?formId=${Formdid1}&authId=${columnID1}`,
        { headers }
      )
      .then(response => {
        console.log('response.dataaaaa: ', response.address
        )

        if (response && response.id > 0) {
          // setTaxId(response.taxId);
          // setNpi(response.npi);
          setAddNotes(response.additionalNotes)
          setReferringProvider(response.referringProvider);
          setReferringProviderNpi(response.referringProviderNpi);
          setPriorAuthRequestFormId(response.id)
          setCodevob(response.procedureCode1)
          setdegdvob(response.diagnosisCode1)
          setcpap(response.cpap)
          setappliance(response.appliance)
          setGAP(response.gap)
          setProdiceridvob(response.provider_id)
        }
        else
          setPriorAuthRequestFormId(-1)
        // fields.forEach(field => {
        //   setValue(field, response[field])
        // })

        // setFormDataId(response.formId)

      })

      .catch(error => {
        console.error('There was an error!', error)
      })

    // empty dependency array means this effect will only run once (like componentDidMount in classes)
  }, [Formdid1, columnID])

  useEffect(() => {
    if (priorAuthRequestFormId == -1) {
      axios
        .get(
          `${process.env.REACT_APP_API_URL}/PatientNote/AuthorizationFormByCPTById?Id=${columnID}`,
          // `${process.env.REACT_APP_API_URL}/PatientNote/AuthorizationFormByCPTById?Id=${columnIDcpt}&authId=${columnIDcpt}`,
          { headers }
        )
        .then(response => {
          setdegdvob(response[0].iCD)
          setCodevob(response[0].cptcode)
          setdegdvob(response[0].iCD)
          setProdiceridvob(response[0].providerId)
          setReferringProvider(response[0].referringProvider);

        })

        .catch(error => {
          console.error('There was an error!', error)
        })
    }


    // empty dependency array means this effect will only run once (like componentDidMount in classes)
  }, [columnIDcpt, priorAuthRequestFormId])
  console.log('Testing testing__________',props.Source)
  useEffect(() => {
    setLoading(true);
    axios
      .get(
        `${process.env.REACT_APP_API_URL}/AutherizationRequest/AuthApprovalFormById?Id=${Formdid}&authId=${props.Source === 'Authoorization' ? columnID : 0}&authCPTId=${props.Source === 'AuthorizationFormByCPT' ? columnID : 0}`,
        // `${process.env.REACT_APP_API_URL}/AutherizationRequest/AuthApprovalFormById?Id=${Formdid}&authId=${columnID}`,
        { headers }
      )
      .then(async(response) => {
        setLoading(false)
        fields.forEach((field) => {
          setValue(field, response[field]);
        });
        // setTaxId(response.taxId);
        // setNpi(response.npi);
        // setReferringProvider(response.referringProvider);
        // setReferringProviderNpi(response.referringProviderNpi);
        setPatId(response.id)
        setPatName(response.patientName)
        // var dateYMD = Moment(response.dob).format('YYYY-MM-DD')
        // setpatientdob(dateYMD)
        // setPatQuestion(response.patientQuestionnaire)
        var rdate = Moment(response.rangeDate).format('YYYY-MM-DD')
        setRangeDate(rdate)
        if (response.rangeDate) {
          var rdate = Moment(response.rangeDate).format('YYYY-MM-DD')
          setRangeDate(rdate)
        } else {
          setRangeDate('');
        }
        if (response.rangeDateform) {
          const rdate = Moment(response.rangeDateform).format('YYYY-MM-DD');
          setRangeDateform(rdate);
        } else {
          setRangeDateform('');
        }
        setrangecomments(response.rangecomments)
        setbackofficecomment(response.backOffice)
        if(response.insuranceEffectiveDate){
        var insudate = Moment(response.insuranceEffectiveDate).format('YYYY-MM-DD')
        setInsuDate(insudate)
        }else{
        setInsuDate('')

        }
        setInduDeduct(response.individualDeductible)
        setInduAmou(response.individualAmountMet)
        setRemaDeduct(response.remainingDeductible)
        setFamDeduct(response.familyDeductible)
        setFamAmount(response.familyAmountMet)
        setprimaryInsurance(response.primaryInsurance)
        // setInsuName(response.insuranceName)
        // setPolName(response.policyNumber)
        // setPhoneNumber(response.phoneNumber)
        setRepName(response.representativeName)
        setContract(response.contract)
        setInNetwork(response.inNetwork)
        setOutNetwork(response.outNetwork)
        setContractYear(response.contractYear)
        setCellReference(response.cellReference)
        setApproval(response.approval)

        // setPAuthNmbr(response.preAuthorizationNumber)
        setApDentist(response.approvedDentist)
        setPauthTreatment(response.preAuthorizationTreatment)
        setApprovedAppliance(response.approvedAppliance)
        setCoInsu(response.coInsurancePercAllowable)
        setCoInsuRespon(response.coInsurancePercPatRespon)
        setPInsurance(response.primaryInsurance === false ? false : true);
        setestimatedAllowable(response.estimatedAllowable)
        settotalEstimated(response.totalEstimated)
        // setInactive(response.inactive)
        // setPracticeId(response.practiceId)
        // setCreatedBy(response.createdBy)
        // var CreatedDate = Moment(response.createdDate).format('YYYY-MM-DD')
        // setCreatedDate(CreatedDate)
        if(response.cellDate){
        var CellDate = Moment(response.cellDate).format('YYYY-MM-DD')
        setCellDate(CellDate)
      }else{
        setCellDate('')

        }
        // setUpdatedBy(response.updatedBy)
        // var UpdatedDate = Moment(response.updatedDate).format('YYYY-MM-DD')
        // setUpdatedDate(UpdatedDate)
        // var CcDate = Moment(response.clientCreatedDate).format('YYYY-MM-DD')
        // setCcDate(CcDate)
        // var CUDate = Moment(response.clientUpdatedDate).format('YYYY-MM-DD')
        // setCUDate(CUDate)
        setCalendarYear(response.calenderYear)
        // setProvName(response.providerName)
        setcellPhone(response.preAuthorizationNumber)
  const hasPrimaryInsurance =
        response.primaryInsurance_Name ||
        response.primaryInsurance_MemberId ||
        response.primaryInsurance_PayerId;

      const hasSecondaryInsurance =
        response.secondaryInsurance_Name ||
        response.secondaryInsurance_MemberId ||
        response.secondaryInsurance_PayerId;

      // ✅ Always call patient API using AuthPatientId
      await fetchInsuranceFromPatient(AutpattientID, {
        shouldUpdateInsurance: !hasPrimaryInsurance && !hasSecondaryInsurance,
      });

      })

      .catch(error => {
        console.error('There was an error!', error)
      })

    // empty dependency array means this effect will only run once (like componentDidMount in classes)
  }, [Formdid, columnID, patName])
const fetchInsuranceFromPatient = async (AutpattientID, options = { shouldUpdateInsurance: true }) => {
  try {
    if (!AutpattientID) return;

    const res = await axios.get(
      `${process.env.REACT_APP_API_URL}/Patients/SearchInsuranceName?patientId=${AutpattientID}`,
      { headers }
    );

    const data = res;
    if (!Array.isArray(data) || data.length === 0) return;

    const Data = data[0];

    // ✅ Always update patient info
    const dateYMD = Moment(Data.dob).format("YYYY-MM-DD");
    setDOB(dateYMD);
    setpatientdiercttname(Data.patientName);
    setpatientphone(Data.phoneNumber);

    // ✅ Only update insurance fields if first API had missing values
    if (options.shouldUpdateInsurance) {
      const primary = data.find((r) => r.type?.toLowerCase() === "primary");
      const secondary = data.find((r) => r.type?.toLowerCase() === "secondary");

      if (primary) {
        setValue("primaryInsurance_Name", primary.planName || "");
        setValue("primaryInsurance_MemberId", primary.memberId || "");
        setValue("primaryInsurance_PayerId", primary.payerId || "");
      }

      if (secondary) {
        setValue("secondaryInsurance_Name", secondary.planName || "");
        setValue("secondaryInsurance_MemberId", secondary.memberId || "");
        setValue("secondaryInsurance_PayerId", secondary.payerId || "");
      }
    }
  } catch (err) {
    console.error("❌ Error fetching insurance from patient:", err);
  }
};



  useEffect(() => {
    // POST request using axios inside useEffect React hook
    axios
      .get(`${process.env.REACT_APP_API_URL}/Procedures/Procedures`, {
        headers
      })
      .then(response => {
        var prac = [];
        response.forEach(field => {
          prac.push({
            label: field.code,
            value: field.code,


          });

        });
        setProcedureCode1List(prac);

      })
      .catch(error => { });

  }, []);
  useEffect(() => {
    // POST request using axios inside useEffect React hook
    axios
      .get(`${process.env.REACT_APP_API_URL}/Diagnosis/Diagnosis`, {
        headers
      })
      .then(response => {
        var prac = [];
        response.forEach(field => {
          prac.push({
            label: field.code,
            value: field.code
          });
        });
        setDiagnosisList(prac);

      })
      .catch(error => { });

  }, []);

  const PriorPracticeID = props.PriorPracticeID
  console.log('Testing tesing Tes',props.Markaporoved)
  useEffect(
    () => {
      // setProviders([]);
      // setValue("provider_id", null);
      // if (userPractice != null || userPractice != undefined || userPractice > 0) {
      // POST request using axios inside useEffect React hook
      if (PriorPracticeID == practiceID) {
        axios
          .get(
            `${process.env.REACT_APP_API_URL}/Providers/getPracticeProvider?parcticeid=${practiceID}`,
            { headers }
          )
          .then(response => {
            var prov = [];
            response.forEach(field => {
              prov.push({
                label: field.name,
                value: field.id,
                npi: field.npi,     // ✅ Add this
                taxId: field.taxId
              });
            });
            setProviders(prov);
          })
          .catch(error => { });
      } else {
        axios
          .get(
            `${process.env.REACT_APP_API_URL}/Providers/getPracticeProvider?patientid=${AutpattientID}`,
            { headers }
          )
          .then(response => {
            var prov = [];
            response.forEach(field => {
              prov.push({
                label: `${field.firstName}${field.lastName}`,
                value: field.id,
                npi: field.nPI,     // ✅ Add this
                taxId: field.taxId
              });
            });
            setProviders(prov);
          })
          .catch(error => { });
      }
    }, [practiceID]
  );
  const [referringProvider1List, setReferringProvider1List] = useState([]);
  useEffect(() => {
    if (PriorPracticeID == practiceID) {
      axios
        .get(
          `${process.env.REACT_APP_API_URL}/ReferringPhysicians/ReferringPhysicians?parcticeid=${practiceID}`,
          { headers }
        )
        .then(response => {
          const bprov = response.map(field => ({
            label: `${field.firstName} ${field.lastName}`, // Updated label format
            value: field.id,
            npi: field.npi,
          }));

          setReferringProvider1List(bprov);
        })
        .catch(error => {
          console.error("Error fetching referring physicians:", error);
        });
    } else {
      axios
        .get(
          `${process.env.REACT_APP_API_URL}/ReferringPhysicians/ReferringPhysicians?patientid=${AutpattientID}`,
          { headers }
        )
        .then(response => {
          const bprov = response.map(field => ({
            label: `${field.firstName} ${field.lastName}`, // Updated label format
            value: field.id,
            npi: field.npi,
          }));

          setReferringProvider1List(bprov);
        })
        .catch(error => { });
    }
  }, [practiceID,]);
  const onSubmit = (data, archived = false) => {

   if (!validateForm()) {
    return; 
  }
    setSubmitting(true);
    setdisable(true)
    const postData = data;
    const postData1 = data;
    const postdatanew = {
      id: columnID,
      approved: true,
      submission: true,
      approval: true,
      practiceId: data.practiceId,
      patientId: props.AutpattientID1,
      AuthRequest: false,
      createdBy: props.CreatedBy,
      createdDate: props.CreatedDate,
      archived: archived,
      dateSubmission: props.DateofSubmission,
      lomn:props.lomn,
      questionnaire:props.Quetionare,
     cptCode :props.Charge1


    }
    postData.practiceId = data.practiceId
    postData.id = patId
    postData.authId = props.Source === 'Authoorization' ? columnID : null
    postData.approved = true
    postData.authCPTId = props.Source === 'AuthorizationFormByCPT' ? columnID : null
    // postData.authId = columnID
    // postData.authCPTId=columnID
    postData.patientName = props.patientNameee
    postData.patientId = props.AutpattientID1
    postData.representativeName = repName
    postData.calenderYear = ccyear
    postData.contract = contract
    postData.contractYear = contractYear
    postData.insuranceEffectiveDate = insuDate
    postData.cellDate = cellDate
    postData.coInsurancePercAllowable = coInsu
    postData.coInsurancePercPatRespon = coInsuRespon
    postData.inNetwork = inNetwork
    postData.outNetwork = outNetwork
    postData.individualDeductible = induDeduct
    postData.individualAmountMet = induAmou
    postData.remainingDeductible = remaDeduct
    postData.familyDeductible = famDeduct
    postData.familyAmountMet = famAmount
    postData.primaryInsurance = pInsurance
    postData.preAuthorizationTreatment = pauthTreatment
    postData.preAuthorizationNumber = cellPhone
    postData.approvedDentist = apDentist
    postData.approval = approval


    postData.rangeDate = rangeDate
    postData.rangeDateform = rangeDateform
    postData.estimatedAllowable = estimatedAllowable
    postData.totalEstimated = totalEstimated
    postData.rangecomments = rangecomments
    postData.backOffice = backofficecomment
    postData.archived = archived;
    postData.cellReference = cellReference
    postData.cptCode =props.Charge1
    axios
      .post(
        `${process.env.REACT_APP_API_URL}/AutherizationRequest/AddAuthApprovalForm`,
        postData,
        {
          headers,
        }
      )
      .then((response) => {
        if (response.id > 0) {
          setSubmitting(false);

          toast.success('Record saved successfully', {
            position: "bottom-center",
            autoClose: 1500,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",

            onClose: () => {

              props.updateHealthHistory(response.id, response.authId, response.authCPTId)


              console.log('checkid', response.id)
              setdisable(false);
              props.handleClose4()
            },

          });

        } else {
          setSubmitting(false);
          setdisable(false);

        }
      })
      .catch((error) => {
        setSubmitting(false);
        setdisable(false);
        alert.success(`Error ${error.message}`, {
          type: "error",
        });
      });
      // let apiEndpoint = '';

      // if (props.Source === 'Authoorization') {
      //   apiEndpoint = `${process.env.REACT_APP_API_URL}/AutherizationRequest/AddAuthorization`;
      // } else if (props.Source === 'AuthorizationFormByCPT') {
      //   apiEndpoint = `${process.env.REACT_APP_API_URL}/PatientNote/AddAuthorizationFormByCPT`;
      // } else {
      //   console.error("Unknown source:", props.Source);
      //   return; // Stop execution if source is invalid
      // }
      
      // axios
      //   .post(apiEndpoint, postdatanew, { headers })
      //   .then((response) => {
      //     // handle successful response here
      //     console.log("Success:", response.data);
      //   })
      //   .catch((error) => {
      //     console.error("There was an error!", error);
      //   });
   
    
      const id = columnID; // or cell.row.id
      const approved = true; // true or false
      const today = new Date().toLocaleDateString('en-US'); // MM/DD/YYYY

      const source =  props.Source === 'Authoorization'
      ? 'authoorization'
      : props.Source === 'AuthorizationFormByCPT'
      ? 'authorizationformbycpt'
      : '';
      
      axios
        .post(
          `${process.env.REACT_APP_API_URL}/Dashboard/UpdatedDashboard?Id=${id}&Approved=${approved}&source=${source}&archived=${archived}&unApproved=${false}&approvedDate=${today}`,
          null,
          { headers }
        )
        .then((response) => {
          console.log('✅ updateAuthBySource success:', response.data);
        })
        .catch((error) => {
          console.error('❌ updateAuthBySource error:', error);
        });
  };

  const saveunappored = (data) => {
     if (!validateForm()) {
    return; 
  }
    setSubmitting(true);
    setdisable(true)
    const postData = data;
    const postData1 = data;

    const postdatanew = {
      id: columnID,
      approved: false,
      submission: false,
      approval: false,
      practiceId: data.practiceId,
      patientId: props.AutpattientID1,
      AuthRequest: true,
      dateSubmission: props.DateofSubmission,
      createdBy: props.CreatedBy,
      createdDate: props.CreatedDate,
      lomn:props.lomn,
      questionnaire:props.Quetionare,
      cptCode :props.Charge1
    }
    postData.practiceId = data.practiceId
    postData.id = patId
    postData.approved = false
    postData.authId = props.Source === 'Authoorization' ? columnID : null
    postData.authCPTId = props.Source === 'AuthorizationFormByCPT' ? columnID : null
    // postData.authId = columnID
    // postData.authCPTId=columnID
    postData.patientName = props.patientNameee
    postData.patientId = props.AutpattientID1
    postData.representativeName = repName
    postData.calenderYear = ccyear
    postData.contract = contract
    postData.contractYear = contractYear
    postData.insuranceEffectiveDate = insuDate
    postData.cellDate = cellDate
    postData.coInsurancePercAllowable = coInsu
    postData.coInsurancePercPatRespon = coInsuRespon
    postData.inNetwork = inNetwork
    postData.outNetwork = outNetwork
    postData.individualDeductible = induDeduct
    postData.individualAmountMet = induAmou
    postData.remainingDeductible = remaDeduct
    postData.familyDeductible = famDeduct
    postData.familyAmountMet = famAmount
    postData.primaryInsurance = pInsurance
    postData.preAuthorizationTreatment = pauthTreatment
    postData.preAuthorizationNumber = cellPhone
    postData.approvedDentist = apDentist
    postData.approval = approval
    postData.rangeDate = rangeDate
    postData.rangeDateform = rangeDateform
    postData.estimatedAllowable = estimatedAllowable
    postData.totalEstimated = totalEstimated
    postData.rangecomments = rangecomments
    postData.backOffice = backofficecomment
    postData.cptCode =props.Charge1
    postData.cellReference = cellReference
    axios
      .post(
        `${process.env.REACT_APP_API_URL}/AutherizationRequest/AddAuthApprovalForm`,
        postData,
        {
          headers,
        }
      )
      .then((response) => {
        if (response.id) {
          setSubmitting(false);
          toast.success('Record saved successfully', {
            position: "bottom-center",
            autoClose: 1500,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            onClose: () => {
              props.updateHealthHistory(response.id, response.authId)
              console.log('checkid', response.id)
              setdisable(false);
              props.handleClose4()
            },

          });

        } else {
          setSubmitting(false);
          setdisable(false);

        }
      })
      .catch((error) => {
        setSubmitting(false);
        setdisable(false);
        alert.success(`Error ${error.message}`, {
          type: "error",
        });
      });
      
      const id = columnID; // or cell.row.id
      const approved = false; // true or false
      const source =  props.Source === 'Authoorization'
      ? 'authoorization'
      : props.Source === 'AuthorizationFormByCPT'
      ? 'authorizationformbycpt'
      : '';
      
      axios
        .post(
          `${process.env.REACT_APP_API_URL}/Dashboard/UpdatedDashboard?Id=${id}&Approved=${approved}&source=${source}&unApproved=${false}&archived=${false}`,
          null,
          { headers }
        )
        .then((response) => {
          console.log('✅ updateAuthBySource success:', response.data);
        })
        .catch((error) => {
          console.error('❌ updateAuthBySource error:', error);
        });
  };
  const Markunappored = (data) => {
     if (!validateForm()) {
    return; 
  }
    setSubmitting(true);
    setdisable(true)
    const postData = data;
    const postData1 = data;

    const postdatanew = {
      id: columnID,
      approved: false,
    }
    postData.practiceId = practiceID
    postData.id = patId
    postData.approved = true
    postData.unApproved = true
    postData.authId = props.Source === 'Authoorization' ? columnID : null
    postData.authCPTId = props.Source === 'AuthorizationFormByCPT' ? columnID : null
    // postData.authId = columnID
    // postData.authCPTId=columnID
    postData.patientName = props.patientNameee
    postData.patientId = props.AutpattientID1
    postData.representativeName = repName
    postData.calenderYear = ccyear
    postData.contract = contract
    postData.contractYear = contractYear
    postData.insuranceEffectiveDate = insuDate
    postData.cellDate = cellDate
    postData.coInsurancePercAllowable = coInsu
    postData.coInsurancePercPatRespon = coInsuRespon
    postData.inNetwork = inNetwork
    postData.outNetwork = outNetwork
    postData.individualDeductible = induDeduct
    postData.individualAmountMet = induAmou
    postData.remainingDeductible = remaDeduct
    postData.familyDeductible = famDeduct
    postData.familyAmountMet = famAmount
    postData.primaryInsurance = pInsurance
    postData.preAuthorizationTreatment = pauthTreatment
    postData.preAuthorizationNumber = cellPhone
    postData.approvedDentist = apDentist
    postData.approval = approval
    postData.rangeDate = rangeDate
    postData.rangeDateform = rangeDateform
    postData.estimatedAllowable = estimatedAllowable
    postData.totalEstimated = totalEstimated
    postData.rangecomments = rangecomments
    postData.backOffice = backofficecomment
    postData.cptCode =props.Charge1
    postData.cellReference = cellReference
    axios
      .post(
        `${process.env.REACT_APP_API_URL}/AutherizationRequest/AddAuthApprovalForm`,
        postData,
        {
          headers,
        }
      )
      .then((response) => {
        if (response.id) {
          console.log("check Data", response);
          setSubmitting(false);
          toast.success('Record saved successfully', {
            position: "bottom-center",
            autoClose: 1500,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            onClose: () => {
              props.updateHealthHistory(response.id, response.authId)
              console.log('checkid', response.id)
              setdisable(false);
              props.handleClose4()
            },

          });

        } else {
          setSubmitting(false);
          setdisable(false);

        }
      })
      .catch((error) => {
        setSubmitting(false);
        setdisable(false);
        alert.success(`Error ${error.message}`, {
          type: "error",
        });
      });
      const id = columnID; // or cell.row.id
      const approved = true; // true or false
      const today = new Date().toLocaleDateString('en-US'); // MM/DD/YYYY
      const source =  props.Source === 'Authoorization'
      ? 'authoorization'
      : props.Source === 'AuthorizationFormByCPT'
      ? 'authorizationformbycpt'
      : '';
      
      axios
        .post(
          `${process.env.REACT_APP_API_URL}/Dashboard/UpdatedDashboard?Id=${id}&Approved=${approved}&source=${source}&unApproved=${true}&archived=${false}&approvedDate=${today}`,
          null,
          { headers }
        )
        .then((response) => {
          console.log('✅ updateAuthBySource success:', response.data);
        })
        .catch((error) => {
          console.error('❌ updateAuthBySource error:', error);
        });
  };

  const handlePrint1 = useReactToPrint({
    content: () => printRef1.current,
    onBeforeGetContent: () => {
      setPrintPage(true);
    },
    onAfterPrint: () => {
      setPrintPage(false);
    },

  });

  useEffect(() => {
    console.log("printRef1 in useEffect:", printRef1.current);
    if (printpage) {
      // Delay the execution to ensure the printing content is ready
      handlePrint1()
    }
  }, [printpage]);

  useEffect(() => {
    if (prodiceridvob && providers.length > 0) {
      const selectedProvider = providers.find(
        option => option.value === prodiceridvob
      );

      if (selectedProvider) {
        setValue("providerId", selectedProvider.value);
        setValue("npi", selectedProvider.npi);
        setValue("taxId", selectedProvider.tin);
        setNpi(selectedProvider.npi);
        setTaxId(selectedProvider.taxId);
        console.log("Testtttttttt", npi, taxId, selectedProvider)
      }
    }
  }, [prodiceridvob, providers]);
  const [openpatientreg, setOpenpatientreg] = React.useState(false);
  const handleOpenpatientreg = () => setOpenpatientreg(true);
  const handleClosepatientreg = () => setOpenpatientreg(false);
  const styleDetailspatient = {
    width: '90%',
    height: 600,
    bgcolor: 'white',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    margin: 'auto',
    marginTop: '10px',
    paddingBottom: '10px',
    padding: '20px',
    overflow: 'auto',
    zIndex: 1500,
    scrollbarWidth: 'thin',
    scrollbarColor: '#356F60 transparent',
    '&::-webkit-scrollbar': {
      width: 8,
      height: 8,
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: '#356F60',
      borderRadius: 10,
    },
    '&::-webkit-scrollbar-track': {
      backgroundColor: 'transparent',
    },
    '&::-webkit-scrollbar-thumb:horizontal': {
      width: 4,
    },
  };
  const customSelectStyles = {
    control: (provided, state) => ({
      ...provided,
      borderColor: '#d32f2f', // Red border
      boxShadow: state.isFocused ? '0 0 0 1px #d32f2f' : provided.boxShadow,
      '&:hover': {
        borderColor: '#b71c1c', // Darker red on hover
      },
    }),
    singleValue: (provided) => ({
      ...provided,
      color: '#d32f2f', // Red text
      fontWeight: 'bold',
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      color: '#d32f2f',
    }),
    indicatorSeparator: (provided) => ({
      ...provided,
      backgroundColor: '#d32f2f',
    }),
  };
  useEffect(() => {
    if (!columnID) return;
  
    axios
      .get(`${process.env.REACT_APP_API_URL}/PatientDocument/PatientDocumentList?authId=${columnID}&type=lomn`, { headers })
      .then((response) => {
        const data = response
  
        if (Array.isArray(data) && data.length > 0) {
          const referringId = data[0]?.referringPhysiciansId ?? "";
  
          const matchedProvider = referringProvider1List.find(
            (option) => String(option.value) === String(referringId)
          );
          // setValue("referringProvider", referringId);
          // setValue("referringProviderNpi", matchedProvider?.npi ?? "");
          setReferringProviderNpi(matchedProvider?.npi ?? "")
          setReferringProvider(referringId)
  
        }
      })
      .catch((error) => {
        console.error("Error fetching PatientDocumentList:", error);
      });
  }, [columnID, referringProvider1List]);
  const [showDropdown, setShowDropdown] = useState(false);
  const [userList, setUserList] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);

 useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_URL}/Users/getUsers`, { headers })
      .then((response) => {
         var prov = [];
            response.forEach(field => {
              prov.push({
                label: field.fullName,
                value:field.id
              });
            });
            setUserList(prov);
      })
      .catch((error) => {});
  }, [showDropdown]);
  const handleSendEmail = async () => {
  if (!selectedUser) {
    toast.error("Please select a user first!", {
      position: "bottom-center",
      autoClose: 1500,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
      style: { zIndex: 1800 }, // <-- yaha z-index set kiya
    });
    return;
  }

  try {
    const res = await axios.post(
      `${process.env.REACT_APP_API_URL}/AutherizationRequest/sendAuthorizationUpdate?userId=${selectedUser}&patientId=${AutpattientID}`,null,
      { headers }
    );

    toast.success('Email sent successfully', {
      position: "bottom-center",
      autoClose: 1500,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
      style: { zIndex: 1800 }, // <-- z-index
      onClose: () => {
        setSelectedUser(null);
        setShowDropdown(false);
      },
    });

  } catch (err) {
    console.error(err);
    toast.error("Failed to send email.", {
      position: "bottom-center",
      autoClose: 1500,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
      style: { zIndex: 1800 }, // <-- z-index
    });
  }
};
useEffect(() => {
  if (selectedUser) {
    handleSendEmail();
  }
}, [selectedUser]);
  return (
    <div>
      <Modal
        open={openpatientreg}
        onClose={handleClosepatientreg}
        sx={{ zIndex: 1701 }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={styleDetailspatient}>
          <Grid container columnSpacing={1}>
            <Grid item xs={6} style={{ fontWeight: 500 }}>
              <Typography style={{ fontWeight: "bold", color: "black", }}>
                Patient Registration
              </Typography>
            </Grid>
            <Grid item xs={6} style={{ fontWeight: 500 }}>
              <Button
                onClick={handleClosepatientreg}
                style={{
                  marginTop: '0px',
                  marginBottom: '10px',
                  float: 'right',
                  marginLeft: '10px',
                  width: '90px',
                  height: '35px',
                  // backgroundColor: '#A574FD',
                  color: 'white',
                  fontSize: '14px'
                }}
              >
                <CancelOutlinedIcon
                  fontSize="medium"
                  style={{ color: "red", paddingRight: "5px" }}
                ></CancelOutlinedIcon>
              </Button>
            </Grid>
            <Grid item xs={12} style={{ fontWeight: 500, marginTop: '-90px', }}>
              <PatientRegistration callingFrom={"Authorization"} pid={AutpattientID} handleClosepatientreg={handleClosepatientreg}></PatientRegistration>
            </Grid>

          </Grid>
        </Box>
      </Modal>
      <Container>
        {isLoading ? (
          <div style={{ margin: '15rem', textAlign: 'center' }}>
            <CircularProgress />
          </div>
        ) : (<>
          <Grid container style={{ color: "black" }} spacing={1} >
            <Grid item xs={8}></Grid>
            {((PatientIdOfdemographics === 0 || PatientIdOfdemographics == null || PatientIdOfdemographics == undefined) && props.callingFromAuthoriazation === 'AUTH') ? (
              <Grid item xs={3}>
                <Button
                  className="Button"
                  variant="contained"
                  color="info"
                  fullWidth
                  style={{
                    float: 'left',
                    height: '30px',
                    marginTop: '8px',
                  }}
                  size="small"
                  onClick={handleOpenpatientreg}
                >
                  Go to patient Chart
                </Button>
              </Grid>
            ) : (
              <Grid item xs={3}></Grid>
            )}

            <Grid item xs={1}>
              <PrintIcon
                onClick={handlePrint1}
                fontSize="large"
                style={{
                  color: 'white',
                  paddingRight: '5px',
                  cursor: 'pointer',
                  float: 'right',
                  color: '356F60'
                }}
              ></PrintIcon>
            </Grid>
            <Grid item xs={1}></Grid>
            <Grid item xs={3} sm={3} xl={3}>
              <Typography
                variant="subtitle1"
                sx={{
                  mt: '8px',
                  fontWeight: 'bold',
                  color: '#d32f2f', // Material Red 700
                }}>
                Procedure Code(s):123
              </Typography>
            </Grid>
            <Grid item xs={4} sm={4} xl={4} style={{ marginTop: "10px" }}>
              {/* <Controller
                name="procedureCode"
                {...register("procedureCode")}
                control={control}
                render={({ field }) =>
                  <ReactSelect
                    {...field}
                    fullWidth
                    value={procedureCode1List.find(option => option.value === codevob)}
                    onChange={e => {
                      console.log('eeee', e)
                      setValue("procedureCode", e.value);
                      setProcedureCode1ID(e.value);
                    }}
                    options={procedureCode1List}
                  // styles={customStyles}
                  />

                }
              /> */}

              <Controller
                name="procedureCode"
                {...register("procedureCode")}
                control={control}
                render={({ field }) => {
                  const selectedOption = procedureCode1List.find(option => option.value == codevob);
                  const fallbackOption = { label: codevob, value: codevob };
                  return (
                    <ReactSelect
                      {...field}
                      fullWidth
                      value={selectedOption || fallbackOption}
                      onChange={e => {
                        setValue("procedureCode", e.value);
                        setProcedureCode1ID(e.value);
                        setCodevob(e.value);

                      }}
                      styles={customSelectStyles}
                      options={procedureCode1List}
                    />
                  );
                }}
              />
            </Grid>

            <Grid item xs={4}></Grid>
            <Grid item xs={1}></Grid>
            <Grid item xs={3}>
              <Typography
                variant="subtitle1"
                sx={{
                  mt: '8px',
                  fontWeight: 'bold',
                  color: '#d32f2f', // Material Red 700
                }}>
                Diagnosis Code(s):
              </Typography>
            </Grid>
            <Grid item xs={4} sm={4} xl={4} >

              <Controller
                name="diagnosisCode"
                {...register("diagnosisCode")}
                control={control}
                render={({ field }) =>
                  <ReactSelect
                    {...field}
                    fullWidth
                    value={diagnosisList.find(option => option.value === degvob)}
                    // value={diagnosisList.filter(function(option) {
                    //   return (
                    //     option.value === getValues("diagnosisCode")
                    //   );
                    // })}
                    onChange={e => {
                      setValue("diagnosisCode", e.value);
                      setDiagnosisID(e.value);

                    }}
                    styles={customSelectStyles}
                    options={diagnosisList}
                  />

                }
              />
            </Grid>

            <Grid item xs={4}></Grid>
            <Grid item xs={1}></Grid>
            {/* <Grid item xs={4} >
      <Typography
        sx={{
          marginTop: "20px",

        }}
      >
        *Name of Dr(provider) Rendering Service:
      </Typography>
      </Grid> */}
            <Grid item xs={4}>
              <Typography style={{ fontSize: "17px" }}>
                *Name of Dr(provider) Rendering Service:
              </Typography>
              <Controller
                name="providerId"
                control={control}
                render={({ field }) => (
                  <ReactSelect
                    {...field}
                    size="small"
                    value={providers.find(option => option.value === prodiceridvob)}
                    isDisabled={props.Markaporoved}
                    onChange={option => {
                      if (option) {
                        setValue("providerId", option.value);
                        setProvidersid(option.value);
                        setValue("npi", option.npi);
                        setValue("taxId", option.tin);
                        setNpi(option.npi);
                        setTaxId(option.taxId);
                      }
                    }}
                    options={providers}
                  />
                )}
              />

            </Grid>
            <Grid xs={0.5}>
            </Grid>
            <Grid xs={2.5} mt={0.5}>
              <Typography style={{ fontSize: "17px" }}>
                Service Provider TIN:
              </Typography>
              <Controller
                name="taxId"
                {...register("taxId")}
                control={control}
                render={({ field }) => (
                  <TextField
                    value={taxId}
                    onChange={e => {
                      setTaxId(e.target.value);
                      field.onChange(e);
                    }}
                    InputProps={{ readOnly: true }}
                    disabled
                    size="small"
                    fullWidth
                  />

                )}
              />
            </Grid>
            <Grid xs={0.5}></Grid>
            <Grid xs={2.5}>
              <Typography style={{ fontSize: "17px" }}>
                Service Provider NPI:
              </Typography>
              <Controller
                name="npi"
                {...register("npi")}
                control={control}
                render={({ field }) => (
                  <TextField
                    value={npi}  // ✅ Controlled by state
                    onChange={e => {
                      setNpi(e.target.value);
                      field.onChange(e);
                    }}
                    InputProps={{ readOnly: true }}
                    disabled
                    size="small"
                    fullWidth
                  />

                )}
              />
            </Grid>
            <Grid xs={1}></Grid>
            <Grid xs={1}></Grid>

            <Grid item xs={5}>
              <Typography style={{ fontSize: "17px" }}>
                Referring Provider Name:
              </Typography>
              <Controller
                name="referringProvider"
                {...register("referringProvider")}
                control={control}
                render={({ field }) =>
                  <ReactSelect
                    fullWidth
                    value={referringProvider1List.find(option => option.value == referringProvider)}
                    onChange={e => {
                      setReferringProvider(e.value);
                      setReferringProviderNpi(e.npi);
                      setValue("referringProvider", e.value)
                      setValue("referringProviderNpi", e.npi)
                    }}
                    options={referringProvider1List}
                  />

                }
              />
            </Grid>
            <Grid xs={0.5}></Grid>
            <Grid xs={4} mt={0.5}>
              <Typography style={{ fontSize: "17px" }}>
                Referring Provider NPI:
              </Typography>
              <Controller
                name="referringProviderNpi"
                control={control}
                render={({ field }) => (
                  <TextField
                    size="small"
                    fullWidth
                    value={referringProviderNpi}  // ✅ Controlled by state
                    onChange={e => {
                      setReferringProviderNpi(e.target.value);
                      field.onChange(e);
                    }}
                    InputProps={{ readOnly: true }}
                    disabled
                  />

                )}
              />
            </Grid>
            <Grid item xs={1}></Grid>
            <Grid container sx={{ marginTop: "20px" }}>
              <Grid item xs={1}></Grid>
              <Grid item xs={1.3}>
                <Typography
                  sx={{
                    marginTop: "10px",
                  }}
                >
                  Patient Name:
                </Typography>
              </Grid>
              <Grid item xs={2.5} >
                <Controller

                  name="patientName"
                  // {...register("patientName")}
                  control={control}

                  render={({ field }) => (
                    <TextField size="small" variant="standard" {...field}
                      InputProps={{
                        readOnly: true,
                      }}
                      fullWidth
                      value={patientdiercttname}
                      onChange={e => {
                        setValue('patientName', e.target.value)
                        setpatientdiercttname(e.target.value)


                      }}
                      inputProps={{
                        readOnly: true,  // Corrected prop name
                      }}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={0.1}></Grid>
              <Grid item xs={0.6}>
                <Typography
                  sx={{
                    marginTop: "10px",

                    // marginLeft: "20px",
                  }}
                >
                  DOB:
                </Typography>
              </Grid>
              <Grid item xs={2.5}>
                <Controller
                  name="dob"
                  control={control}
                  render={({ field }) => (
                    <TextField
                      type="date"
                      size="small"
                      variant="standard"
                      {...field}
                      fullWidth
                      value={dob}
                      onChange={(e) => {
                        setValue('dob', e.target.value);
                        setDOB(e.target.value);
                      }}
                      InputProps={{
                        readOnly: true,
                      }}

                    />
                  )}
                />



              </Grid>
              <Grid item xs={0.1}></Grid>
              <Grid item xs={1.1}  >
                <Typography
                  sx={{
                    marginTop: "10px",
                  }}
                >
                  Phone No:
                </Typography>
              </Grid>
              <Grid item xs={2} sx={{ marginLeft: "-10px" }} >
                <TextField
                  size="small"
                  variant="standard"
                  fullWidth
                  disabled
                  value={patientphone}
                  inputProps={{
                    readOnly: true,  // Corrected prop name
                  }}
                />
              </Grid>
            </Grid>

             <Grid container sx={{ marginTop: "5px" }} spacing={1}>
                <Grid item xs={1}></Grid>
                <Grid item xs={10}>
                  <Typography
                    sx={{
                      marginTop: "10px",
                      fontWeight: "bold",
                      textDecoration: "underline",
                    }}
                  >
                    Primary Insurance:
                  </Typography>
                </Grid>
                <Grid item xs={1}></Grid>
                <Grid item xs={1}></Grid>

                <Grid item xs={10} sx={{ display: 'flex', justifyContent: 'flex-start', marginTop: '10px' }}>
                  <Button
                    size="small"
                    variant="outlined"
                    onClick={() => fetchInsuranceFromPatient(AutpattientID, { shouldUpdateInsurance: true })}
                  >
                    Fetch Insurance
                  </Button>
                </Grid>
                <Grid item xs={1}></Grid>


                <Grid item xs={1}></Grid>
                <Grid item xs={1.5}>
                  <Typography
                    sx={{
                      marginTop: "10px",
                    }}
                  >
                    Insurance
                  </Typography>
                </Grid>
                <Grid item xs={3} sx={{ marginLeft: "-10px" }}>
                  <Controller
                    name="primaryInsurance_Name"
                    control={control}
                    render={({ field }) => (
                      <TextField
                        fullWidth
                        size="small"
                        variant="standard"
                        {...field}
                        inputProps={{
                          readOnly: true, // Corrected prop name
                        }}
                        disabled
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={1}></Grid>
                <Grid item xs={1.5} style={{ marginLeft: "15px" }}>
                  <Typography
                    sx={{
                      marginTop: "10px",
                    }}
                  >
                    Member Id:
                  </Typography>
                </Grid>
                <Grid item xs={3} sx={{ marginLeft: "-10px" }}>
                  <Controller
                    name="primaryInsurance_MemberId"
                    control={control}
                    render={({ field }) => (
                      <TextField
                        size="small"
                        variant="standard"
                        fullWidth
                        {...field}
                        inputProps={{
                          readOnly: true, // Corrected prop name
                        }}
                        disabled
                      />
                    )}
                  />
                </Grid>
                {/* <Grid item xs={1.5} style={{ marginLeft: "15px" }}>
                  <Typography
                    sx={{
                      marginTop: "10px",
                    }}
                  >
                    Payer Id:
                  </Typography>
                </Grid>
                <Grid item xs={1.5} sx={{ marginLeft: "-10px" }}>
                  <Controller
                    name="primaryInsurance_PayerId"
                    control={control}
                    render={({ field }) => (
                      <TextField
                        size="small"
                        variant="standard"
                        fullWidth
                        {...field}
                        inputProps={{
                          readOnly: true,
                        }}
                        disabled
                      />
                    )}
                  />
                </Grid> */}
                <Grid item xs={1}></Grid>
              </Grid>

              <Grid container sx={{ marginTop: "5px" }} spacing={1}>
                <Grid item xs={1}></Grid>
                <Grid item xs={10}>
                  <Typography
                    sx={{
                      marginTop: "10px",
                      fontWeight: "bold",
                      textDecoration: "underline",
                    }}
                  >
                    Secondary Insurance:
                  </Typography>
                </Grid>
                <Grid item xs={1}></Grid>
                <Grid item xs={1}></Grid>
                <Grid item xs={1.5}>
                  <Typography
                    sx={{
                      marginTop: "10px",
                    }}
                  >
                    Insurance
                  </Typography>
                </Grid>
                <Grid item xs={3} sx={{ marginLeft: "-10px" }}>
                  <Controller
                    name="secondaryInsurance_Name"
                    control={control}
                    render={({ field }) => (
                      <TextField
                        InputProps={{
                          readOnly: true,
                        }}
                        size="small"
                        {...field}
                        variant="standard"
                        style={{ width: "90%" }}
                        disabled
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={1}></Grid>

                <Grid item xs={1.5} style={{ marginLeft: "15px" }}>
                  <Typography
                    sx={{
                      marginTop: "10px",
                    }}
                  >
                    Member Id:
                  </Typography>
                </Grid>
                <Grid item xs={3} sx={{ marginLeft: "-10px" }}>
                     <Controller
                    name="secondaryInsurance_MemberId"
                    control={control}
                    render={({ field }) => (
                  <TextField
                    size="small"
                    variant="standard"
                    fullWidth
                    {...field}
                    inputProps={{
                      readOnly: true, // Corrected prop name
                    }}
                    disabled
                  />
                    )}
                  />
                </Grid>
                {/* <Grid item xs={1.5} style={{ marginLeft: "15px" }}>
                  <Typography
                    sx={{
                      marginTop: "10px",
                    }}
                  >
                    Payer Id:
                  </Typography>
                </Grid>
                <Grid item xs={1.5} sx={{ marginLeft: "-10px" }}>
                       <Controller
                    name="secondaryInsurance_PayerId"
                    control={control}
                    render={({ field }) => (
                  <TextField
                    size="small"
                    variant="standard"
                    fullWidth
                     {...field}
                    inputProps={{
                      readOnly: true,
                    }}
                    disabled
                  />
                       )}
                  />
                </Grid> */}
                <Grid item xs={1}></Grid>
              </Grid>

            <Grid container sx={{ marginTop: "20px" }}>
              <Grid item xs={1}></Grid>
              <Grid item xs={2}>
                <Typography
                  sx={{
                    marginTop: "10px",

                  }}
                >
                  Representative Name:
                </Typography>
              </Grid>
              <Grid item xs={2} >
                <Controller
                  name="representativeName"
                  // {...register("representativeName")}
                  control={control}
                  render={({ field }) => (
                    <TextField
                      size="small"
                      variant="standard"
                      {...field}
                      fullWidth
                      value={repName}
                      onChange={e => {
                        setValue('representativeName', e.target.value)
                        setRepName(e.target.value)
                      }}
                    />
                  )}
                />
              </Grid>


              <Grid item xs={1}></Grid>

              <Grid item xs={1.2}>
                <Typography
                  sx={{
                    marginTop: "10px",
                  }}
                >
                  Date Of Call:
                </Typography>
              </Grid>
              <Grid item xs={3} >
                <Controller
                  name="cellDate"
                  // {...register("cellDate")}
                  control={control}
                  render={({ field }) => (
                    <TextField
                      type="date"
                      size="small"
                      variant="standard"
                      {...field}
                      style={{ width: "45%" }}

                      value={cellDate}
                      onChange={e => {
                        setValue('cellDate', e.target.value)
                        setCellDate(e.target.value)
                      }}
                    />
                  )}
                />
              </Grid>
              {/* <Grid item xs={0.5}></Grid> */}
            </Grid>

            <Grid container sx={{ marginTop: "20px" }}>
              <Grid item xs={1} ></Grid>
              <Grid item xs={2.2}>
                <Typography
                  sx={{
                    marginTop: "10px",

                  }}
                >
                  Insurance Effective Date:
                </Typography>
              </Grid>
              <Grid item xs={2} >
                <Controller
                  name="insuranceEffectiveDate"
                  // {...register("insuranceEffectiveDate")}
                  control={control}
                  render={({ field }) => (
                    <TextField
                      type="date"
                      size="small"
                      variant="standard"
                      {...field}
                      style={{ width: "100%" }}

                      value={insuDate}
                      onChange={e => {
                        setValue('insuranceEffectiveDate', e.target.value)
                        setInsuDate(e.target.value)
                      }}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={0.5} ></Grid>

              <Grid item xs={1.4}  >
                <Typography
                  sx={{
                    marginTop: "10px",
                    // marrginLeft: "20px",

                  }}
                >
                  Calender Year:
                </Typography>
              </Grid>

              <Grid item xs={1.2} >
                <Controller
                  name="calenderYear"
                  // {...register("calenderYear")}
                  control={control}
                  render={({ field }) => (
                    <TextField
                      type="text"
                      size="small"
                      variant="standard"

                      {...field}
                      // inputProps={{
                      //   inputMode: 'numeric',
                      //   pattern: '[0-9]*',
                      //   onInput: (e) => {
                      //     const inputValue = e.target.value.trim();
                      //     if (inputValue === '' || /^[0-9]*$/.test(inputValue)) {
                      //       e.target.value = inputValue !== '' ? Math.max(0, parseInt(inputValue)).toString().slice(0, 10) : ''; // Allow only positive integers
                      //     } else {
                      //       e.target.value = ''; // Set value to empty if non-numeric input
                      //     }
                      //     field.onChange(e);
                      //   },
                      // }}
                      value={ccyear}
                      onChange={e => {
                        setValue('calenderYear', e.target.value)
                        setCalendarYear(e.target.value)
                      }}

                      fullWidth
                    />
                  )}
                />
              </Grid>
              <Grid item xs={0.5}  ></Grid>

              <Grid item xs={1.2}>
                <Typography
                  sx={{
                    marginTop: "10px",
                    // marrginLeft: "20px",

                  }}
                >
                  Or Contract:
                </Typography>
              </Grid>

              <Grid item xs={1.5}  >
                <Controller
                  name="contract"
                  // {...register("contract")}
                  control={control}
                  render={({ field }) => (
                    <TextField
                      type="text"
                      size="small"
                      variant="standard"
                      {...field}
                      // inputProps={{
                      //   inputMode: 'numeric',
                      //   pattern: '[0-9]*',
                      //   onInput: (e) => {
                      //     const inputValue = e.target.value.trim();
                      //     if (inputValue === '' || /^[0-9]*$/.test(inputValue)) {
                      //       e.target.value = inputValue !== '' ? Math.max(0, parseInt(inputValue)).toString().slice(0, 10) : ''; // Allow only positive integers
                      //     } else {
                      //       e.target.value = ''; // Set value to empty if non-numeric input
                      //     }
                      //     field.onChange(e);
                      //   },
                      // }}
                      value={contract}
                      onChange={e => {
                        setValue('contract', e.target.value)
                        setContract(e.target.value)
                      }}
                      fullWidth
                    />
                  )}
                />
              </Grid>
            </Grid>

            <Grid item xs={0.5}>

            </Grid>
          </Grid>

          <Grid container sx={{ marginTop: "20px" }}>
            <Grid item xs={3}></Grid>
            <Grid item xs={2}>
              <Typography
                sx={{
                  marginTop: "10px",
                  // float: "right",
                }}
              >
                If Contract Year?:
              </Typography>
            </Grid>
            <Grid item xs={4} >
              <Controller
                name="contractYear"
                // {...register("contractYear")}
                control={control}
                render={({ field }) => (
                  <TextField
                    type="text"
                    size="small"
                    variant="standard"
                    {...field}
                    // inputProps={{
                    //   inputMode: 'numeric',
                    //   pattern: '[0-9]*',
                    //   onInput: (e) => {
                    //     const inputValue = e.target.value.trim();
                    //     if (inputValue === '' || /^[0-9]*$/.test(inputValue)) {
                    //       e.target.value = inputValue !== '' ? Math.max(0, parseInt(inputValue)).toString().slice(0, 10) : ''; // Allow only positive integers
                    //     } else {
                    //       e.target.value = ''; // Set value to empty if non-numeric input
                    //     }
                    //     field.onChange(e);
                    //   },
                    // }}
                    fullWidth
                    value={contractYear}
                    onChange={e => {
                      setValue('contractYear', e.target.value)
                      setContractYear(e.target.value)
                    }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={3}></Grid>

          </Grid>
          <Grid container spacing={1}>
            <Grid item xs={3}></Grid>
            <Grid item xs={2}>
              <Typography
                sx={{
                  marginTop: "10px",
                  // float: "right",
                }}
              >
                Primary insurance
              </Typography>
            </Grid>
            <Grid item xs={4}>
              <div>
                <input
                  type="radio"
                  name="primaryInsurance"
                  checked={pInsurance ? true : false}
                  onClick={(e) => {
                    setValue('primaryInsurance', true)
                    setPInsurance(true)

                  }}

                  style={{ marginLeft: "20px", marginTop: "12px" }}
                />{" "}
                Yes
                <input
                  type="radio"
                  checked={pInsurance ? false : true}
                  onClick={(e) => {
                    setValue("primaryInsurance", false);
                    setPInsurance(false);
                  }}
                  style={{ marginLeft: "20px" }}
                />{" "}
                No
              </div>

            </Grid>
            <Grid item xs={3}></Grid>
          </Grid>


          <Grid container sx={{ marginTop: "20px" }}>
            {/* <Grid item xs={3.5}></Grid> */}
            <Grid item xs={3}></Grid>
            <Grid item xs={1}>
              <Typography
                sx={{
                  marginTop: "10px",
                  // float: "right",
                }}
              >
                Co-ins
              </Typography>
            </Grid>
            <Grid item xs={3}>
              <Controller
                name="coInsurancePercAllowable"
                // {...register("coInsurancePercAllowable")}
                control={control}
                render={({ field }) => (
                  <TextField
                    type='text'
                    size="small"
                    variant="standard"
                    {...field}
                    fullWidth
                    value={coInsu}
                    onChange={e => {
                      setValue('coInsurancePercAllowable', e.target.value)
                      setCoInsu(e.target.value)
                    }}
                    style={{
                      paddingLeft: '3px'
                    }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={2}>
              <Typography
                sx={{
                  marginTop: "10px",
                  // float: "left",
                }}
              >
                % of Allowable
              </Typography>
            </Grid>
            <Grid item xs={3}></Grid>
          </Grid>
          <Grid container spacing={1}>
            <Grid item xs={3}></Grid>
            <Grid item xs={6}>
              <Typography>(What the ins-co will take responsibility for)</Typography>
            </Grid>
            <Grid item xs={3}></Grid>

          </Grid>


          <Grid container sx={{ marginTop: "20px" }}>
            <Grid item xs={3}></Grid>
            <Grid item xs={1}>
              <Typography
                sx={{
                  marginTop: "10px",
                  // float: "right",
                }}
              >
                Co-ins
              </Typography>
            </Grid>
            <Grid item xs={2}>
              <Controller
                name="coInsurancePercPatRespon"
                // {...register("coInsurancePercPatRespon")}
                control={control}
                render={({ field }) => (
                  <TextField
                    type='text'
                    size="small"
                    variant="standard"
                    {...field}
                    fullWidth
                    value={coInsuRespon}
                    onChange={e => {
                      setValue('coInsurancePercPatRespon', e.target.value)
                      setCoInsuRespon(e.target.value)
                    }}

                    style={{
                      paddingLeft: '3px'
                    }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={3}>
              <Typography
                sx={{
                  marginTop: "10px",
                  float: "left",
                }}
              >
                (Patient responsibility)
              </Typography>
            </Grid>
            <Grid item xs={3}></Grid>
          </Grid>

          <Grid container sx={{ marginTop: "20px" }}>
            <Grid item xs={1}></Grid>
            <Grid item xs={1.1}>
              <Typography
                sx={{
                  marginTop: "10px",

                }}
              >
                In Network:
              </Typography>
            </Grid>
            <Grid item xs={2} >
              <Controller
                name="inNetwork"
                // {...register("inNetwork")}
                control={control}
                render={({ field }) => (
                  <TextField
                    size="small"
                    variant="standard"
                    {...field}
                    value={inNetwork}
                    onChange={e => {
                      setValue('inNetwork', e.target.value)
                      setInNetwork(e.target.value)
                    }}
                    fullWidth

                  />
                )}
              />
            </Grid>
            <Grid item xs={1.5}></Grid>
            <Grid item xs={1.5}>
              <Typography
                sx={{
                  marginTop: "10px",

                }}
              >
                Out-Of-Network:
              </Typography>
            </Grid>
            <Grid item xs={2} >
              <Controller
                name="outNetwork"
                // {...register("outNetwork")}
                control={control}
                render={({ field }) => (
                  <TextField
                    size="small"
                    variant="standard"
                    {...field}
                    value={outNetwork}
                    onChange={e => {
                      setValue('outNetwork', e.target.value)
                      setOutNetwork(e.target.value)
                    }}
                    fullWidth

                  />
                )}
              />
            </Grid>
            <Grid item xs={2}></Grid>
          </Grid>

          <Grid container>
            <Grid item xs={1}></Grid>
            <Grid item xs={3.5}>
              <Typography>
                *You may not balance bill the patient unless the EOB states
                otherwise
              </Typography>
            </Grid>



            <Grid item xs={1}></Grid>
            <Grid item xs={3.5}>
              {/* <Typography>
                You may not balance bill the patient unless the EOB states
                otherwise123
              </Typography> */}
            </Grid>
            <Grid item xs={1.5}></Grid>
          </Grid>

          <Grid container sx={{ marginTop: "20px" }}>
            <Grid item xs={3.5}></Grid>
            <Grid item xs={2.5}>
              <Typography
                sx={{
                  // marginTop: "10px",
                  marginLeft: "20px",
                }}
              >
                *Individual Deductible : $
              </Typography>
            </Grid>
            <Grid item xs={1}>
              <Controller
                name="individualDeductible"
                // {...register("individualDeductible")}
                control={control}
                render={({ field }) => (
                  <TextField
                    type="text"
                    size="small"
                    variant="standard"
                    {...field}
                    value={induDeduct}
                    onChange={e => {
                      setValue('individualDeductible', e.target.value)
                      setInduDeduct(e.target.value)
                    }}
                    // error={!!errors.individualDeductible}
                    //   helperText={errors.individualDeductible?.message}
                    //             inputProps={{
                    //               inputMode: 'numeric',
                    //               inputMode: 'numeric',
                    // pattern: '^\\d*\\.?\\d[0-9]*$',

                    //               onInput: (e) => {
                    //                 const inputValue = e.target.value.trim();
                    //                 if (inputValue === '' || /^\d*\.?\d[0-9]*$/.test(inputValue)) {
                    //                   e.target.value = inputValue !== '' ? parseFloat(inputValue).toFixed(2) : ''; 
                    //                 } else {
                    //                   e.target.value = ''; 
                    //                 }
                    //                 field.onChange(e);
                    //               },
                    //             }}

                    fullWidth
                  />
                )}
              />
            </Grid>

            <Grid item xs={4.5}></Grid>
          </Grid>

          <Grid container sx={{ marginTop: "20px" }}>
            <Grid item xs={4}></Grid>
            <Grid item xs={2}>
              <Typography
                sx={{
                  marginLeft: "10px",
                }}
              >
                Amount met: $
              </Typography>
            </Grid>
            <Grid item xs={1} sx={{ marginLeft: "-33px" }}>
              <Controller
                name="individualAmountMet"
                // {...register("individualAmountMet")}
                control={control}
                render={({ field }) => (
                  <TextField
                    type="text"
                    size="small"
                    variant="standard"
                    {...field}
                    value={induAmou}
                    onChange={e => {
                      setValue('individualAmountMet', e.target.value)
                      setInduAmou(e.target.value)
                    }}
                    fullWidth
                  // error={!!errors.individualAmountMet}
                  // helperText={errors.individualAmountMet?.message}

                  />
                )}
              />
            </Grid>
            <Grid item xs={4}></Grid>
          </Grid>

          <Grid container sx={{ marginTop: "20px" }}>
            <Grid item xs={4}></Grid>
            <Grid item xs={2.4}>
              <Typography
                sx={{
                  // marginTop: "10px",
                  // marginLeft : "70px"
                }}
              >
                Remaining Deductible: $
              </Typography>
            </Grid>
            <Grid item xs={1} sx={{ marginLeft: "-10px" }}>
              <Controller
                name="remainingDeductible"
                // {...register("remainingDeductible")}
                control={control}
                render={({ field }) => (
                  <TextField
                    type="text"
                    size="small"
                    variant="standard"
                    {...field}
                    value={remaDeduct}
                    onChange={e => {
                      setValue('remainingDeductible', e.target.value)
                      setRemaDeduct(e.target.value)
                    }}
                    fullWidth
                  // error={!!errors.remainingDeductible}
                  // helperText={errors.remainingDeductible?.message}
                  />
                )}
              />
            </Grid>
            <Grid item xs={4}></Grid>
          </Grid>

          <Grid container sx={{ marginTop: "20px" }}>
            <Grid item xs={4}></Grid>
            <Grid item xs={2.5}>
              <Typography
                sx={{
                  // marginTop: "10px",
                  marginLeft: "15px",
                }}
              >
                *Family Deductible: $
              </Typography>
            </Grid>
            <Grid item xs={1} sx={{ marginLeft: "-30px" }}>
              <Controller
                name="familyDeductible"
                // {...register("familyDeductible")}
                control={control}
                render={({ field }) => (
                  <TextField
                    type="text"
                    size="small"
                    variant="standard"
                    {...field}
                    value={famDeduct}
                    onChange={e => {
                      setValue('familyDeductible', e.target.value)
                      setFamDeduct(e.target.value)
                    }}
                    fullWidth
                  // error={!!errors.familyDeductible}
                  // helperText={errors.familyDeductible?.message}
                  />
                )}
              />
            </Grid>
            <Grid item xs={4}></Grid>
          </Grid>

          <Grid container sx={{ marginTop: "20px" }}>
            <Grid item xs={4}></Grid>
            <Grid item xs={2.2}>
              <Typography
                sx={{
                  // marginTop: "10px",
                  marginLeft: "40px",
                }}
              >
                Amount met: $
              </Typography>
            </Grid>
            <Grid item xs={1} sx={{ marginLeft: "-30px" }}>
              <Controller
                name="familyAmountMet"
                // {...register("familyAmountMet")}
                control={control}
                render={({ field }) => (
                  <TextField
                    type="text"
                    size="small"
                    variant="standard"
                    {...field}
                    value={famAmount}
                    onChange={e => {
                      setValue('familyAmountMet', e.target.value)
                      setFamAmount(e.target.value)
                    }}
                    fullWidth
                  // error={!!errors.familyAmountMet}
                  // helperText={errors.familyAmountMet?.message}
                  />
                )}
              />
            </Grid>
            <Grid item xs={4}></Grid>
          </Grid>

          <Grid container sx={{ marginTop: "20px" }}>
            <Grid item xs={1}></Grid>
            <Grid item xs={5.2}>
              <Typography
                sx={{
                  marginTop: "10px",
                  marginLeft: "10px",
                }}
              >
                *Is pre-authorization needed before treatment?
              </Typography>
            </Grid>

            <Grid item xs={2} sx={{ marginLeft: "-80px" }}>
              <div>
                <input
                  type="radio"
                  name="preAuthorizationTreatment"
                  checked={pauthTreatment ? true : false}
                  onClick={(e) => {
                    setValue('preAuthorizationTreatment', true)
                    setPauthTreatment(true)

                  }}

                  style={{ marginLeft: "20px", marginTop: "12px" }}
                />{" "}
                Yes
                <input
                  type="radio"
                  checked={pauthTreatment ? false : true}
                  onClick={(e) => {
                    setValue("preAuthorizationTreatment", false);
                    setPauthTreatment(false);
                  }}
                  style={{ marginLeft: "20px" }}
                />{" "}
                No
              </div>

            </Grid>
            <Grid item xs={0.8}>
              <Typography
                sx={{
                  marginTop: "10px",
                  marginLeft: "-2px"
                }}
              >
                Phone :
              </Typography>
            </Grid>
            <Grid item xs={1.6} >
              <InputMask
                mask='+1 999-999-9999'
                disabled={false}
                value={cellPhone}
                style={{ height: '30px' }}
                onChange={e => {
                  setValue('preAuthorizationNumber', e.target.value)
                  setcellPhone(e.target.value)
                }}
              >
                {() => <TextField id='outlined-basic' variant="standard" fullWidth size='small' />}
              </InputMask>
              {/* <Controller
          name="preAuthorizationNumber"
        
          control={control}
          render={({ field }) => (
            <TextField
           
              size="small"
              variant="standard"
              {...field}
              fullWidth
              value={patientphone}
              onChange={e => {
                setValue('preAuthorizationNumber', e.target.value)
                setpatientphone(e.target.value)
              }}
            />
          )}
        /> */}
            </Grid>
            <Grid item xs={0.5}></Grid>
          </Grid>


          <Grid container sx={{ marginTop: "20px" }}>
            <Grid item xs={1}></Grid>
            <Grid item xs={5.5}>
              <Typography
                sx={{
                  marginTop: "10px",
                  marginLeft: "70px",
                }}
              >
                Has the patient used CPAP in the past?
              </Typography>
            </Grid>
            <Grid item xs={5}>
              <Controller
                name="cpap"
                control={control}
                render={({ field }) => (
                  <TextField
                    type="text"
                    size="small"
                    variant="standard"
                    {...field}
                    value={cpap}
                    onChange={e => {
                      setValue('cpap', e.target.value)
                      setcpap(e.target.value)
                    }}
                    InputProps={{
                      readOnly: true,
                    }}

                    fullWidth
                  />
                )}
              />
            </Grid>
            <Grid item xs={1}></Grid>
            <Grid item xs={5.5}>
              <Typography
                sx={{
                  marginTop: "10px",
                  marginLeft: "70px",
                }}
              >
                Has the patient has an oral appliance in the past?
              </Typography>
            </Grid>
            <Grid item xs={5}>
              <Controller
                name="appliance"
                control={control}
                render={({ field }) => (
                  <TextField
                    type="text"
                    size="small"
                    variant="standard"
                    {...field}
                    value={appliance}
                    onChange={e => {
                      setValue('appliance', e.target.value)
                      setappliance(e.target.value)
                    }}
                    InputProps={{
                      readOnly: true,
                    }}

                    fullWidth
                  />
                )}
              />
            </Grid>
            <Grid item xs={1}></Grid>
            <Grid item xs={6}>
              <Typography
                sx={{
                  marginTop: "10px",
                  marginLeft: "70px",
                }}
              >
                Would you like to obtain GAP (if available on plan)?
              </Typography>
            </Grid>
            <Grid item xs={4.5}>
              <Controller
                name="gap"
                control={control}
                render={({ field }) => (
                  <TextField
                    type="text"
                    size="small"
                    variant="standard"
                    {...field}
                    value={GAP}
                    onChange={e => {
                      setValue('gap', e.target.value)
                      setGAP(e.target.value)
                    }}
                    InputProps={{
                      readOnly: true,
                    }}

                    fullWidth
                  />
                )}
              />
            </Grid>




          </Grid>
          <Grid container>
            <Grid item xs={4}></Grid>
            <Grid item xs={1}>
              <Typography
                sx={{
                  marginTop: "10px",
                  // marginLeft : "70px"
                }}
              >
                Approval :
              </Typography>
            </Grid>
            <Grid item xs={3}>
              <Controller
                name="approval"
                // {...register("approval")}
                control={control}
                render={({ field }) => (
                  <TextField
                    type="text"
                    size="small"
                    variant="standard"
                    {...field}
                    value={approval}
                    onChange={e => {
                      setValue('approval', e.target.value)
                      setApproval(e.target.value)
                    }}
                    // error={!!errors.approval}
                    // helperText={errors.approval?.message}

                    fullWidth
                  />
                )}
              />
            </Grid>
            <Grid item xs={4}></Grid>
          </Grid>

          {approval == '' ? (<></>) : (<>

            <Grid container sx={{ marginTop: "20px" }}>
              <Grid item xs={4}></Grid>
              <Grid item xs={1.5}>
                <Typography
                  sx={{
                    marginTop: "10px",
                    marginLeft: "20px",
                  }}
                >
                  Date Range :
                </Typography>
              </Grid>

              <Grid item xs={1}>
                <Typography
                  sx={{
                    marginTop: "10px",
                    marginLeft: "20px",
                  }}
                >
                  From:
                </Typography>
              </Grid>
              <Grid item xs={2} >

                <Controller
                  name="rangeDateform"
                  control={control}
                  render={({ field }) => (
                    <TextField
                      type="date"
                      size="small"
                      variant="standard"
                      {...field}
                      fullWidth
                      value={rangeDateform}
                      onChange={e => {
                        setValue('rangeDateform', e.target.value)
                        setRangeDateform(e.target.value)
                      }}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={0.5}>
              </Grid>
              <Grid item xs={0.5}>

                <Typography
                  sx={{
                    marginTop: "10px",

                  }}
                >
                  To:
                </Typography>
              </Grid>
              <Grid item xs={1.5} >

                <Controller
                  name="rangeDate"
                  // {...register("rangeDate")}

                  control={control}
                  render={({ field }) => (
                    <TextField
                      type="date"
                      size="small"
                      variant="standard"
                      {...field}
                      fullWidth
                      value={rangeDate}
                      onChange={e => {
                        setValue('rangeDate', e.target.value)
                        setRangeDate(e.target.value)
                      }}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={1.5}></Grid>


            </Grid>
          </>)}
          <Grid container spacing={1}>
            <Grid item xs={1}></Grid>
            <Grid item xs={3.5}>
              <Typography
                sx={{
                  marginTop: "10px",
                  marginLeft: "20px",
                }}
              >
                Estimated Allowable from Carrier:$
              </Typography>
            </Grid>
            <Grid item xs={1}>
              <Controller
                name="estimatedAllowable"
                // {...register("estimatedAllowable")}
                control={control}
                render={({ field }) => (
                  <TextField
                    type="text"
                    size="small"
                    variant="standard"
                    {...field}
                    value={estimatedAllowable}
                    onChange={e => {
                      setValue('estimatedAllowable', e.target.value)
                      setestimatedAllowable(e.target.value)
                    }}
                    // error={!!errors.estimatedAllowable}
                    // helperText={errors.estimatedAllowable?.message}
                    fullWidth
                  />
                )}
              />
            </Grid>
            <Grid item xs={4}>
              <Typography
                sx={{
                  marginTop: "10px",
                  marginLeft: "20px",
                }}
              >
                Estimated Total Patient Responsibility:$
              </Typography>
            </Grid>
            <Grid item xs={1}>
              <Controller
                name="totalEstimated"
                // {...register("totalEstimated")}
                control={control}
                render={({ field }) => (
                  <TextField
                    type="text"
                    size="small"
                    variant="standard"
                    {...field}
                    value={totalEstimated}
                    onChange={e => {
                      setValue('totalEstimated', e.target.value)
                      settotalEstimated(e.target.value)
                    }}
                    // error={!!errors.totalEstimated}
                    // helperText={errors.totalEstimated?.message}
                    fullWidth
                  />
                )}
              />
            </Grid>
            <Grid item xs={1.5}></Grid>
           <Grid item xs={1}></Grid>
               <Grid item xs={3.5}>
                <Typography
                sx={{
                  marginTop: "10px",
                  marginLeft: "20px",
                }}
              >
                Use a Medicare Approved Appliance
              </Typography>
              </Grid>
               <Grid item xs={3} >
                    <div>
                      <input
                        type="radio"
                        name="approvedAppliance"
                          checked={ApprovedAppliance === 'Yes'}
                        onClick={(e) => {
                               setValue('approvedAppliance', 'Yes');
                          setApprovedAppliance('Yes');
                          setErrorApprovedAppliance('');

                        }}

                        style={{ marginLeft: "20px", marginTop: "12px" }}
                      />{" "}
                      Yes
                      <input
                        type="radio"
                        name="approvedAppliance"
                      checked={ApprovedAppliance === 'No'}
                        onClick={(e) => {
                          setValue('approvedAppliance', 'No');
                          setApprovedAppliance('No');
                          setErrorApprovedAppliance('');
                        }}
                        style={{ marginLeft: "20px" }}
                      />{" "}
                      No/Optional

                       {errorApprovedAppliance && (
      <div style={{ color: 'red', fontSize: '12px', marginTop: '5px' }}>
        {errorApprovedAppliance}
      </div>
    )}
                    </div>

                  </Grid>
                   <Grid item xs={4.5}></Grid>
            {rights?.Auth_Comments && (
              <>
                <Grid item xs={1}></Grid>
                <Grid item xs={5} style={{ marginTop: "10px" }}>
                  <Typography sx={{ fontSize: '0.875rem' }}>
                    Comments
                  </Typography>
                  <Controller
                    name='rangecomments'
                    // {...register('rangecomments')}
                    control={control}
                    render={({ field }) => (
                      <TextareaAutosize
                        aria-label='minimum height'
                        minRows={2}
                        placeholder='Enter comments'
                        style={{
                          width: '100%',
                          borderRadius: '8px',
                          border: '2px solid #black',
                          height: '60px', // set a fixed height here
                        }}
                        {...field}
                        fullWidth
                        value={rangecomments || addNotes}
                        onChange={e => {
                          setValue('rangecomments', e.target.value)
                          setrangecomments(e.target.value)
                        }}
                      />
                    )}
                  />

                </Grid>
              </>

            )}
            {rights?.Auth_backOffice_Comments && (
              <>
                <Grid item xs={5} style={{ marginTop: "10px" }}>
                  <Typography sx={{ fontSize: '0.875rem' }}>
                    Back Office Comments
                  </Typography>
                  <Controller
                    name='backOffice'
                    // {...register('rangecomments')}
                    control={control}
                    render={({ field }) => (
                      <TextareaAutosize
                        aria-label='minimum height'
                        minRows={2}
                        placeholder='Enter comments'
                        style={{
                          width: '100%',
                          borderRadius: '8px',
                          border: '2px solid #black',
                          height: '60px', // set a fixed height here

                        }}
                        {...field}
                        fullWidth
                        value={backofficecomment}
                        onChange={e => {
                          setValue('backOffice', e.target.value)
                          setbackofficecomment(e.target.value)
                        }}
                      />
                    )}
                  />

                </Grid>
                <Grid item xs={1}></Grid>
              </>
            )}
          </Grid>

          <Grid container sx={{ marginTop: "20px" }}>
            <Grid item xs={3}></Grid>
            <Grid item xs={2.1}>
              <Typography
                sx={{
                  marginTop: "10px",
                  // marginLeft : "70px"
                }}
              >
                Cell referenced :
              </Typography>
            </Grid>
            <Grid item xs={3} sx={{ marginLeft: "-50px" }}>
              <Controller
                name="cellReference"
                // {...register("cellReference")}
                control={control}
                render={({ field }) => (
                  <TextField
                    type="text"
                    size="small"
                    variant="standard"
                    {...field}
                    value={cellReference}
                    onChange={e => {
                      setValue('cellReference', e.target.value)
                      setCellReference(e.target.value)
                    }}

                    fullWidth
                  />
                )}
              />
            </Grid>
            <Grid item xs={4}></Grid>


            <Grid container sx={{ marginTop: "20px" }}>
              <Grid item xs={1}></Grid>
              <Grid item xs={3}>
                <Typography
                  sx={{
                    marginTop: "10px",
                    // marginLeft : "70px"
                    fontWeight: 'bold'
                  }}
                >
                  Additional Notes :
                </Typography>
              </Grid>
              <Grid item xs={8}></Grid>
            </Grid>

            <Grid container sx={{ marginTop: "5px", marginBottom: "30px" }}>
              <Grid item xs={1}></Grid>
              <Grid item xs={10}>
                <Typography
                  sx={{
                    marginTop: "10px",
                    // marginLeft : "70px"
                  }}
                >
                  Insurance Disclaimer: "A quote of benefits and/or authorization
                  does not guarantee payment or verify eligibility. Payment or
                  benefits are subject to all terms,condition,limitation, and
                  exclusions of the member's contract at time of service."
                </Typography>
              </Grid>
              <Grid item xs={1}></Grid>
            </Grid>
 <Grid container spacing={2} >
       <Grid item xs={1}></Grid>
       {props.UpdateMessage && (
      <Grid item xs={4}>
        <FormControlLabel
          control={
            <Checkbox
              checked={showDropdown}
              onClick={(e) => setShowDropdown(!showDropdown)}
              color="primary"
            />
          }
          label="Email Notice of Approval Complete"
        />
      </Grid>
 )}
      {/* Dropdown */}
      {showDropdown && (
        <Grid item xs={4}>
           <ReactSelect
                      fullWidth
                     value={userList?.find(option => option.value == selectedUser)}
                      onChange={(option) => setSelectedUser(option.value)}
                    placeholder="Search or Select User"
                      options={userList}
                       styles={{
        menu: (provided) => ({
          ...provided,
          maxHeight: '300px', // max height of dropdown
          overflowY: 'auto',  // enable scroll if options exceed
        }),
        menuList: (provided) => ({
          ...provided,
          maxHeight: '300px',
        }),
      }}
      menuPosition="fixed"
                    />
        </Grid>
      )}

      {/* Send Button */}
      {/* {showDropdown && (
        <Grid item xs={3} >
          <Button
            variant="contained"
            color="primary"
            onClick={handleSendEmail}
            disabled={!selectedUser}
          >
          Send Email
          </Button>
        </Grid>
      )} */}

    </Grid>


          </Grid>

        </>)}


        {printpage && (
          <Grid container style={{ color: "black" }} spacing={0} ref={printRef1} >
            <Grid item xs={12}>
              <Headroom>
                <Grid
                  container
                  style={{
                    backgroundColor: '#356F60', position: 'sticky', top: 0,
                    zIndex: 10000,
                  }}
                >
                  <Grid item xs={12} sm={12} xl={12}>
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        height: '3rem'
                      }}
                    >
                      <DialogTitle
                        style={{
                          flex: 1,
                          textAlign: 'center',
                        }}
                      >
                        <h1
                          style={{
                            fontWeight: 'bold',
                            textAlign: 'center',
                            color: '#fff',
                            textDecoration: 'underline',
                            fontSize: '2rem'

                          }}
                        >
                          Prior_auth & VOB

                        </h1>
                      </DialogTitle>
                      <Typography style={{ color: 'white', marginRight: '10px' }}>Patient Name:</Typography>
                      <Typography style={{ color: 'white', fontWeight: 'bold', marginRight: '60px' }}>{(PpatientName && !patName) && (
                        <div>{PpatientName}</div>
                      )}

                        {(!PpatientName && patName) && (
                          <div>{patName}</div>
                        )}

                        {(!PpatientName && !patName) && (
                          ''
                        )}
                      </Typography>
                      <Typography style={{ color: 'white', marginRight: '10px' }}>ID:</Typography>
                      <Typography style={{ color: 'white', fontWeight: 'bold', marginRight: '60px' }}>{columnID}</Typography>


                    </div>
                  </Grid>
                </Grid>
              </Headroom>
            </Grid>

            <Grid item xs={1}></Grid>
            <Grid item xs={3} sm={3} xl={3}>
              <Typography
                variant="subtitle1"
                sx={{
                  mt: '8px',
                  fontWeight: 'bold',
                  color: '#d32f2f', // Material Red 700
                }}>
                Procedure Code(s):
              </Typography>
            </Grid>
            <Grid item xs={4} sm={4} xl={4} style={{ marginTop: "10px" }}>

              {/* <Controller
                name="procedureCode"
                {...register("procedureCode")}
                control={control}
                render={({ field }) =>
                  <ReactSelect
                    {...field}
                    fullWidth
                    value={procedureCode1List.find(option => option.value === codevob)}
                    // value={procedureCode1List.filter(function(option) {
                    //   return (
                    //     option.value === getValues("procedureCode")
                    //   );
                    // })}
                    onChange={e => {
                      console.log('eeee', e)
                      setValue("procedureCode", e.value);
                      setProcedureCode1ID(e.value);

                    }}

                    options={procedureCode1List}
                  // styles={customStyles}
                  />

                }
              /> */}
              <Controller
                name="procedureCode"
                {...register("procedureCode")}
                control={control}
                render={({ field }) => {
                  const selectedOption = procedureCode1List.find(option => option.value == codevob);
                  const fallbackOption = { label: codevob, value: codevob };
                  return (
                    <ReactSelect
                      {...field}
                      fullWidth
                      value={selectedOption || fallbackOption}
                      onChange={e => {
                        setValue("procedureCode", e.value);
                        setProcedureCode1ID(e.value);
                        setCodevob(e.value);

                      }}
                      styles={customSelectStyles}
                      options={procedureCode1List}
                    />
                  );
                }}
              />
            </Grid>


            <Grid item xs={4}></Grid>
            <Grid item xs={1}></Grid>
            <Grid item xs={3}>
              <Typography
                variant="subtitle1"
                sx={{
                  mt: '8px',
                  fontWeight: 'bold',
                  color: '#d32f2f', // Material Red 700
                }}>
                Diagnosis Code(s):
              </Typography>
            </Grid>
            <Grid item xs={4} mt={2}>

              <Controller
                name="diagnosisCode"
                {...register("diagnosisCode")}
                control={control}
                render={({ field }) =>
                  <ReactSelect
                    {...field}
                    fullWidth
                    value={diagnosisList.find(option => option.value === degvob)}
                    // value={diagnosisList.filter(function(option) {
                    //   return (
                    //     option.value === getValues("diagnosisCode")
                    //   );
                    // })}
                    onChange={e => {
                      setValue("diagnosisCode", e.value);
                      setDiagnosisID(e.value);

                    }}
                    styles={customSelectStyles}
                    options={diagnosisList}
                  />

                }
              />
            </Grid>
            <Grid item xs={4}></Grid>
            <Grid item xs={1}></Grid>
            {/* <Grid item xs={4} >
            <Typography
              sx={{
                marginTop: "20px",
              }}
            >
              *Name of Dr(provider) Rendering Service:
            </Typography>
          </Grid>
          <Grid item xs={3} sm={3} xl={3} sx={{ marginTop:'10px'}}>
      <Controller
        name="providerId"
        // {...register("practiceId")}
        control={control}
        render={({ field }) => (
        <ReactSelect
        {...field}
        default
        size="small"
        style={{
               width: "22em",
           }}
           value={providers.find(option => option.value === prodiceridvob)}
           
        // value={providers.filter(function(option) {
        //   return option.value === getValues("providerId");
        // })}
        isDisabled={props.Markaporoved}
        onChange={value => {
          setValue("providerId", value.value);
          setProvidersid(value.value);
          // setProvName("provider_id", value.value);
          // setProviders(value.value);
        }}
        options={providers}
      />
        )}
      />
    </Grid> */}
            <Grid item xs={4}>
              <Typography style={{ fontSize: "15px" }}>
                *Name of Dr(provider) Rendering Service:
              </Typography>
              <Controller
                name="providerId"
                control={control}
                render={({ field }) => (
                  <ReactSelect
                    {...field}
                    size="small"
                    value={providers.find(option => option.value === prodiceridvob)}
                    isDisabled={props.Markaporoved}
                    onChange={option => {
                      if (option) {
                        setValue("providerId", option.value);
                        setProvidersid(option.value);
                        setValue("npi", option.npi);
                        setValue("taxId", option.tin);
                        setNpi(option.npi);
                        setTaxId(option.tin);
                      }
                    }}
                    options={providers}
                  />
                )}
              />

            </Grid>
            <Grid xs={0.5}>
            </Grid>
            <Grid xs={2.5} mt={0.5}>
              <Typography style={{ fontSize: "17px" }}>
                Service Provider TIN:
              </Typography>
              <Controller
                name="taxId"
                {...register("taxId")}
                control={control}
                render={({ field }) => (
                  <TextField
                    value={taxId}  // ✅ Controlled by state
                    onChange={e => {
                      setTaxId(e.target.value);
                      field.onChange(e);
                    }}
                    InputProps={{ readOnly: true }}
                    disabled
                    size="small"
                    fullWidth
                  />

                )}
              />
            </Grid>
            <Grid xs={0.5}></Grid>
            <Grid xs={2.5}>
              <Typography style={{ fontSize: "17px" }}>
                Service Provider NPI:
              </Typography>
              <Controller
                name="npi"
                {...register("npi")}
                control={control}
                render={({ field }) => (
                  <TextField
                    value={npi}  // ✅ Controlled by state
                    onChange={e => {
                      setNpi(e.target.value);
                      field.onChange(e);
                    }}
                    InputProps={{ readOnly: true }}
                    size="small"
                    fullWidth
                    disabled
                  />

                )}
              />
            </Grid>
            <Grid xs={1}></Grid>
            <Grid xs={1}></Grid>

            <Grid item xs={5}>
              <Typography style={{ fontSize: "17px" }}>
                Referring Provider Name:
              </Typography>
              <Controller
                name="referringProvider"
                {...register("referringProvider")}
                control={control}
                render={({ field }) =>
                  <ReactSelect
                    fullWidth
                    value={referringProvider1List.find(option => option.value == referringProvider)}
                    onChange={e => {
                      setReferringProvider(e.value);
                      setReferringProviderNpi(e.npi);
                      setValue("referringProvider", e.value)
                      setValue("referringProviderNpi", e.npi)
                    }}
                    options={referringProvider1List}
                  />

                }
              />
            </Grid>
            <Grid xs={0.5}></Grid>
            <Grid xs={4} mt={0.5}>
              <Typography style={{ fontSize: "17px" }}>
                Referring Provider NPI:
              </Typography>
              <Controller
                name="referringProviderNpi"
                control={control}
                render={({ field }) => (
                  <TextField
                    size="small"
                    fullWidth
                    value={referringProviderNpi}  // ✅ Controlled by state
                    onChange={e => {
                      setReferringProviderNpi(e.target.value);
                      field.onChange(e);
                    }}
                    InputProps={{ readOnly: true }}
                    disabled
                  />

                )}
              />
            </Grid>
            <Grid item xs={1}></Grid>

            <Grid container spacing={2} alignItems="center" sx={{ mx: 4, my: 2 }}  >
              <Grid item xs={1.8}>
                <Typography sx={{ fontSize: '0.875rem' }}>
                  Patient Name:
                </Typography>
              </Grid>
              <Grid item xs={2.5}>
                <Controller

                  name="patientName"
                  // {...register("patientName")}
                  control={control}
                  render={({ field }) => (
                    <TextField size="small" variant="standard" {...field}
                      fullWidth
                      value={patientdiercttname}
                      onChange={e => {
                        setValue('patientName', e.target.value)
                        setpatientdiercttname(e.target.value)
                      }}
                      inputProps={{
                        readOnly: true,  // Corrected prop name
                      }}
                      disabled
                    />
                  )}
                />
              </Grid>
              <Grid item xs={1}>
                <Typography sx={{ fontSize: '0.875rem' }}>
                  DOB:
                </Typography>
              </Grid>
              <Grid item xs={2}>
                <Controller
                  name="dob"
                  control={control}
                  render={({ field }) => (
                    <TextField
                      type="date"
                      size="small"
                      variant="standard"
                      {...field}
                      value={dob}
                      fullWidth
                      onChange={(e) => {
                        setValue('dob', e.target.value);
                        setDOB(e.target.value);
                      }}
                      InputProps={{
                        readOnly: true,
                      }}
                      disabled
                    />
                  )}
                />



              </Grid>
              <Grid item xs={1.5}>
                <Typography sx={{ fontSize: '0.875rem' }}>Phone No:</Typography>
              </Grid>
              <Grid item xs={2.5}>
                <TextField
                  size="small"
                  variant="standard"
                  fullWidth
                  value={patientphone}
                  inputProps={{
                    readOnly: true,
                  }}
                  disabled
                />
              </Grid>
            </Grid>


                 <Grid container sx={{ marginTop: "5px" }} spacing={1}>
                <Grid item xs={1}></Grid>
                <Grid item xs={10}>
                  <Typography
                    sx={{
                      marginTop: "10px",
                      fontWeight: "bold",
                      textDecoration: "underline",
                    }}
                  >
                    Primary Insurance:
                  </Typography>
                </Grid>
                <Grid item xs={1}></Grid>

                <Grid item xs={1}></Grid>
                <Grid item xs={1.5}>
                  <Typography
                    sx={{
                      marginTop: "10px",
                    }}
                  >
                    Insurance
                  </Typography>
                </Grid>
                <Grid item xs={3} sx={{ marginLeft: "-10px" }}>
                  <Controller
                    name="primaryInsurance_Name"
                    control={control}
                    render={({ field }) => (
                      <TextField
                        fullWidth
                        size="small"
                        variant="standard"
                        {...field}
                        inputProps={{
                          readOnly: true, // Corrected prop name
                        }}
                        disabled
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={1}></Grid>
                <Grid item xs={1.5} style={{ marginLeft: "15px" }}>
                  <Typography
                    sx={{
                      marginTop: "10px",
                    }}
                  >
                    Member Id:
                  </Typography>
                </Grid>
                <Grid item xs={3} sx={{ marginLeft: "-10px" }}>
                  <Controller
                    name="primaryInsurance_MemberId"
                    control={control}
                    render={({ field }) => (
                      <TextField
                        size="small"
                        variant="standard"
                        fullWidth
                        {...field}
                        inputProps={{
                          readOnly: true, // Corrected prop name
                        }}
                        disabled
                      />
                    )}
                  />
                </Grid>
                {/* <Grid item xs={1.5} style={{ marginLeft: "15px" }}>
                  <Typography
                    sx={{
                      marginTop: "10px",
                    }}
                  >
                    Payer Id:
                  </Typography>
                </Grid>
                <Grid item xs={1.5} sx={{ marginLeft: "-10px" }}>
                  <Controller
                    name="primaryInsurance_PayerId"
                    control={control}
                    render={({ field }) => (
                      <TextField
                        size="small"
                        variant="standard"
                        fullWidth
                        {...field}
                        inputProps={{
                          readOnly: true,
                        }}
                        disabled
                      />
                    )}
                  />
                </Grid> */}
                <Grid item xs={1}></Grid>
              </Grid>

              <Grid container sx={{ marginTop: "5px" }} spacing={1}>
                <Grid item xs={1}></Grid>
                <Grid item xs={10}>
                  <Typography
                    sx={{
                      marginTop: "10px",
                      fontWeight: "bold",
                      textDecoration: "underline",
                    }}
                  >
                    Secondary Insurance:
                  </Typography>
                </Grid>
                <Grid item xs={1}></Grid>
                <Grid item xs={1}></Grid>
                <Grid item xs={1.5}>
                  <Typography
                    sx={{
                      marginTop: "10px",
                    }}
                  >
                    Insurance
                  </Typography>
                </Grid>
                <Grid item xs={3} sx={{ marginLeft: "-10px" }}>
                  <Controller
                    name="secondaryInsurance_Name"
                    control={control}
                    render={({ field }) => (
                      <TextField
                        InputProps={{
                          readOnly: true,
                        }}
                        size="small"
                        {...field}
                        variant="standard"
                        style={{ width: "90%" }}
                        disabled
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={1}></Grid>

                <Grid item xs={1.5} style={{ marginLeft: "15px" }}>
                  <Typography
                    sx={{
                      marginTop: "10px",
                    }}
                  >
                    Member Id:
                  </Typography>
                </Grid>
                <Grid item xs={3} sx={{ marginLeft: "-10px" }}>
                     <Controller
                    name="secondaryInsurance_MemberId"
                    control={control}
                    render={({ field }) => (
                  <TextField
                    size="small"
                    variant="standard"
                    fullWidth
                    {...field}
                    inputProps={{
                      readOnly: true, // Corrected prop name
                    }}
                    disabled
                  />
                    )}
                  />
                </Grid>
                {/* <Grid item xs={1.5} style={{ marginLeft: "15px" }}>
                  <Typography
                    sx={{
                      marginTop: "10px",
                    }}
                  >
                    Payer Id:
                  </Typography>
                </Grid>
                <Grid item xs={1.5} sx={{ marginLeft: "-10px" }}>
                       <Controller
                    name="secondaryInsurance_PayerId"
                    control={control}
                    render={({ field }) => (
                  <TextField
                    size="small"
                    variant="standard"
                    fullWidth
                     {...field}
                    inputProps={{
                      readOnly: true,
                    }}
                    disabled
                  />
                       )}
                  />
                </Grid> */}
                <Grid item xs={1}></Grid>
              </Grid>
            <Grid container spacing={2} alignItems="center" sx={{ mx: 4, my: 2 }} >
              <Grid item xs={3}>
                <Typography sx={{ fontSize: '0.875rem' }}>
                  Representative Name:
                </Typography>
              </Grid>
              <Grid item xs={3} >
                <Controller
                  name="representativeName"
                  // {...register("representativeName")}
                  control={control}
                  render={({ field }) => (
                    <TextField
                      size="small"
                      variant="standard"
                      {...field}
                      fullWidth
                      value={repName}
                      onChange={e => {
                        setValue('representativeName', e.target.value)
                        setRepName(e.target.value)
                      }}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={2}>
                <Typography sx={{ fontSize: '0.875rem' }}>
                  Date Of Call:
                </Typography>
              </Grid>
              <Grid item xs={3} >
                <Controller
                  name="cellDate"
                  // {...register("cellDate")}
                  control={control}
                  render={({ field }) => (
                    <TextField
                      type="date"
                      size="small"
                      variant="standard"
                      {...field}
                      fullWidth
                      value={cellDate}
                      onChange={e => {
                        setValue('cellDate', e.target.value)
                        setCellDate(e.target.value)
                      }}
                    />
                  )}
                />
              </Grid>
            </Grid>

            <Grid container spacing={1} alignItems="center" sx={{ mx: 4, my: 2 }} >
              <Grid item xs={3}>
                <Typography sx={{ fontSize: '0.875rem' }}>
                  Insurance Effective Date:
                </Typography>
              </Grid>
              <Grid item xs={2} >
                <Controller
                  name="insuranceEffectiveDate"
                  // {...register("insuranceEffectiveDate")}
                  control={control}
                  render={({ field }) => (
                    <TextField
                      type="date"
                      size="small"
                      variant="standard"
                      {...field}
                      fullWidth

                      value={insuDate}
                      onChange={e => {
                        setValue('insuranceEffectiveDate', e.target.value)
                        setInsuDate(e.target.value)
                      }}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={1.5}  >
                <Typography sx={{ fontSize: '0.875rem' }}>
                  Calender Year:
                </Typography>
              </Grid>

              <Grid item xs={2} >
                <Controller
                  name="calenderYear"
                  // {...register("calenderYear")}
                  control={control}
                  render={({ field }) => (
                    <TextField
                      type="text"
                      size="small"
                      variant="standard"
                      {...field}
                      // inputProps={{
                      //   inputMode: 'numeric',
                      //   pattern: '[0-9]*',
                      //   onInput: (e) => {
                      //     const inputValue = e.target.value.trim();
                      //     if (inputValue === '' || /^[0-9]*$/.test(inputValue)) {
                      //       e.target.value = inputValue !== '' ? Math.max(0, parseInt(inputValue)).toString().slice(0, 10) : ''; // Allow only positive integers
                      //     } else {
                      //       e.target.value = ''; // Set value to empty if non-numeric input
                      //     }
                      //     field.onChange(e);
                      //   },
                      // }}
                      value={ccyear}
                      onChange={e => {
                        setValue('calenderYear', e.target.value)
                        setCalendarYear(e.target.value)
                      }}

                      fullWidth
                    />
                  )}
                />
              </Grid>
              <Grid item xs={2}>
                <Typography sx={{ fontSize: '0.875rem' }}>
                  Or Contract:
                </Typography>
              </Grid>
              <Grid item xs={1.5}>
                <Controller
                  name="contract"
                  // {...register("contract")}
                  control={control}
                  render={({ field }) => (
                    <TextField
                      type="text"
                      size="small"
                      variant="standard"
                      {...field}
                      // inputProps={{
                      //   inputMode: 'numeric',
                      //   pattern: '[0-9]*',
                      //   onInput: (e) => {
                      //     const inputValue = e.target.value.trim();
                      //     if (inputValue === '' || /^[0-9]*$/.test(inputValue)) {
                      //       e.target.value = inputValue !== '' ? Math.max(0, parseInt(inputValue)).toString().slice(0, 10) : ''; // Allow only positive integers
                      //     } else {
                      //       e.target.value = ''; // Set value to empty if non-numeric input
                      //     }
                      //     field.onChange(e);
                      //   },
                      // }}
                      value={contract}
                      onChange={e => {
                        setValue('contract', e.target.value)
                        setContract(e.target.value)
                      }}
                      fullWidth
                    />
                  )}
                />
              </Grid>
            </Grid>

            <Grid container>
              <Grid item xs={12}>
                <Grid
                  container
                  spacing={1}
                  alignItems="center"
                  justifyContent="center" // Center inner items horizontally
                >
                  <Grid item xs={3}>
                    <Typography sx={{ fontSize: '0.875rem', textAlign: 'right' }}>
                      If Contract Year?:
                    </Typography>
                  </Grid>
                  <Grid item xs={4} >
                    <Controller
                      name="contractYear"
                      // {...register("contractYear")}
                      control={control}
                      render={({ field }) => (
                        <TextField
                          type="text"
                          size="small"
                          variant="standard"
                          {...field}
                          // inputProps={{
                          //   inputMode: 'numeric',
                          //   pattern: '[0-9]*',
                          //   onInput: (e) => {
                          //     const inputValue = e.target.value.trim();
                          //     if (inputValue === '' || /^[0-9]*$/.test(inputValue)) {
                          //       e.target.value = inputValue !== '' ? Math.max(0, parseInt(inputValue)).toString().slice(0, 10) : ''; // Allow only positive integers
                          //     } else {
                          //       e.target.value = ''; // Set value to empty if non-numeric input
                          //     }
                          //     field.onChange(e);
                          //   },
                          // }}
                          fullWidth
                          value={contractYear}
                          onChange={e => {
                            setValue('contractYear', e.target.value)
                            setContractYear(e.target.value)
                          }}
                        />
                      )}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            <Grid container>
              <Grid item xs={12}>
                <Grid
                  container
                  spacing={1}
                  alignItems="center"
                  justifyContent="center" // Center inner items horizontally
                >
                  <Grid item xs={3}>
                    <Typography sx={{ fontSize: '0.875rem' }}>
                      Primary insurance
                    </Typography>
                  </Grid>
                  <Grid item xs={4}>
                    <div>
                      <input
                        type="radio"
                        name="primaryInsurance"
                        checked={pInsurance ? true : false}
                        onClick={(e) => {
                          setValue('primaryInsurance', true)
                          setPInsurance(true)

                        }}

                        style={{ marginLeft: "20px", marginTop: "12px" }}
                      />{" "}
                      Yes
                      <input
                        type="radio"
                        checked={pInsurance ? false : true}
                        onClick={(e) => {
                          setValue("primaryInsurance", false);
                          setPInsurance(false);
                        }}
                        style={{ marginLeft: "20px" }}
                      />{" "}
                      No
                    </div>

                  </Grid>
                </Grid>
              </Grid>
            </Grid>

            <Grid container>
              <Grid item xs={12}>
                <Grid
                  container
                  spacing={1}
                  alignItems="center"
                  justifyContent="center"
                  sx={{ my: 2 }}
                >
                  <Grid item xs={1}>
                    <Typography sx={{ fontSize: '0.875rem' }}>
                      Co-ins
                    </Typography>
                  </Grid>
                  <Grid item xs={4}>
                    <Controller
                      name="coInsurancePercAllowable"
                      // {...register("coInsurancePercAllowable")}
                      control={control}
                      render={({ field }) => (
                        <TextField
                          type='text'
                          size="small"
                          variant="standard"
                          {...field}
                          fullWidth
                          value={coInsu}
                          onChange={e => {
                            setValue('coInsurancePercAllowable', e.target.value)
                            setCoInsu(e.target.value)
                          }}
                          style={{
                            paddingLeft: '3px'
                          }}
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={2}>
                    <Typography sx={{ fontSize: '0.875rem' }}>
                      % of Allowable
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            <Grid container>
              <Grid item xs={12}>
                <Grid
                  container
                  spacing={1}
                  alignItems="center"
                  justifyContent="center" // Center inner items horizontally
                >
                  <Grid item xs={7}>
                    <Typography>(What the ins-co will take responsibility for)</Typography>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>

            <Grid container>
              <Grid item xs={12}>
                <Grid
                  container
                  spacing={1}
                  alignItems="center"
                  justifyContent="center"
                  sx={{ my: 2 }}
                >
                  <Grid item xs={1}>
                    <Typography sx={{ fontSize: '0.875rem' }}>
                      Co-ins
                    </Typography>
                  </Grid>
                  <Grid item xs={3}>
                    <Controller
                      name="coInsurancePercPatRespon"
                      // {...register("coInsurancePercPatRespon")}
                      control={control}
                      render={({ field }) => (
                        <TextField
                          type='text'
                          size="small"
                          variant="standard"
                          {...field}
                          fullWidth
                          value={coInsuRespon}
                          onChange={e => {
                            setValue('coInsurancePercPatRespon', e.target.value)
                            setCoInsuRespon(e.target.value)
                          }}

                          style={{
                            paddingLeft: '3px'
                          }}
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={3}>
                    <Typography sx={{ fontSize: '0.875rem' }}>
                      (Patient responsibility)
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>

            <Grid container>
              <Grid item xs={12}>
                <Grid
                  container
                  spacing={1}
                  alignItems="center"
                  justifyContent="center"
                  sx={{ my: 2 }}

                >
                  <Grid item xs={1.5}>
                    <Typography sx={{ fontSize: '0.875rem' }}>
                      In Network:
                    </Typography>
                  </Grid>
                  <Grid item xs={2.5} >
                    <Controller
                      name="inNetwork"
                      // {...register("inNetwork")}
                      control={control}
                      render={({ field }) => (
                        <TextField
                          size="small"
                          variant="standard"
                          {...field}
                          value={inNetwork}
                          onChange={e => {
                            setValue('inNetwork', e.target.value)
                            setInNetwork(e.target.value)
                          }}
                          fullWidth
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={2}>
                    <Typography sx={{ fontSize: '0.875rem' }}>
                      Out-Of-Network:
                    </Typography>
                  </Grid>
                  <Grid item xs={2.5} >
                    <Controller
                      name="outNetwork"
                      // {...register("outNetwork")}
                      control={control}
                      render={({ field }) => (
                        <TextField
                          size="small"
                          variant="standard"
                          {...field}
                          value={outNetwork}
                          onChange={e => {
                            setValue('outNetwork', e.target.value)
                            setOutNetwork(e.target.value)
                          }}
                          fullWidth
                        />
                      )}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>

            <Grid container>
              <Grid item xs={12}>
                <Grid
                  container
                  spacing={1}
                  alignItems="center"
                  justifyContent="center"
                >
                  <Grid item xs={4}>
                    <Typography>
                      *You may not balance bill the patient unless the EOB states
                      otherwise
                    </Typography>
                  </Grid>
                  <Grid item xs={4}>
                    <Typography>
                      You may not balance bill the patient unless the EOB states
                      otherwise
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>

            <Grid container>
              <Grid item xs={12}>
                <Grid
                  container
                  spacing={1}
                  alignItems="center"
                  justifyContent="center"
                  sx={{ my: 2 }}

                >
                  <Grid item xs={3}>
                    <Typography sx={{ fontSize: '0.875rem' }}>
                      *Individual Deductible : $
                    </Typography>
                  </Grid>
                  <Grid item xs={3}>
                    <Controller
                      name="individualDeductible"
                      // {...register("individualDeductible")}
                      control={control}
                      render={({ field }) => (
                        <TextField
                          type="text"
                          size="small"
                          variant="standard"
                          {...field}
                          value={induDeduct}
                          onChange={e => {
                            setValue('individualDeductible', e.target.value)
                            setInduDeduct(e.target.value)
                          }}
                          //             inputProps={{
                          //               inputMode: 'numeric',
                          //               inputMode: 'numeric',
                          // pattern: '^\\d*\\.?\\d[0-9]*$',

                          //               onInput: (e) => {
                          //                 const inputValue = e.target.value.trim();
                          //                 if (inputValue === '' || /^\d*\.?\d[0-9]*$/.test(inputValue)) {
                          //                   e.target.value = inputValue !== '' ? parseFloat(inputValue).toFixed(2) : ''; 
                          //                 } else {
                          //                   e.target.value = ''; 
                          //                 }
                          //                 field.onChange(e);
                          //               },
                          //             }}

                          fullWidth
                        />
                      )}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>

            <Grid container>
              <Grid item xs={12}>
                <Grid
                  container
                  spacing={1}
                  alignItems="center"
                  justifyContent="center"
                  sx={{ my: 2 }}

                >
                  <Grid item xs={3}>
                    <Typography sx={{ fontSize: '0.875rem' }}>
                      Amount met: $
                    </Typography>
                  </Grid>
                  <Grid item xs={3} sx={{ marginLeft: "-33px" }}>
                    <Controller
                      name="individualAmountMet"
                      // {...register("individualAmountMet")}
                      control={control}
                      render={({ field }) => (
                        <TextField
                          type="text"
                          size="small"
                          variant="standard"
                          {...field}
                          value={induAmou}
                          onChange={e => {
                            setValue('individualAmountMet', e.target.value)
                            setInduAmou(e.target.value)
                          }}
                          fullWidth

                        />
                      )}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>

            <Grid container>
              <Grid item xs={12}>
                <Grid
                  container
                  spacing={1}
                  alignItems="center"
                  justifyContent="center"
                  sx={{ my: 2 }}

                >
                  <Grid item xs={3}>
                    <Typography sx={{ fontSize: '0.875rem' }}>
                      Remaining Deductable: $
                    </Typography>
                  </Grid>
                  <Grid item xs={3} sx={{ marginLeft: "-10px" }}>
                    <Controller
                      name="remainingDeductible"
                      // {...register("remainingDeductible")}
                      control={control}
                      render={({ field }) => (
                        <TextField
                          type="text"
                          size="small"
                          variant="standard"
                          {...field}
                          value={remaDeduct}
                          onChange={e => {
                            setValue('remainingDeductible', e.target.value)
                            setRemaDeduct(e.target.value)
                          }}
                          fullWidth
                        />
                      )}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>

            <Grid container>
              <Grid item xs={12}>
                <Grid
                  container
                  spacing={1}
                  alignItems="center"
                  justifyContent="center"
                  sx={{ my: 2 }}

                >
                  <Grid item xs={3}>
                    <Typography sx={{ fontSize: '0.875rem' }}>
                      *Family Deductable: $
                    </Typography>
                  </Grid>
                  <Grid item xs={3} >
                    <Controller
                      name="familyDeductible"
                      // {...register("familyDeductible")}
                      control={control}
                      render={({ field }) => (
                        <TextField
                          type="text"
                          size="small"
                          variant="standard"
                          {...field}
                          value={famDeduct}
                          onChange={e => {
                            setValue('familyDeductible', e.target.value)
                            setFamDeduct(e.target.value)
                          }}
                          fullWidth
                        />
                      )}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>

            <Grid container>
              <Grid item xs={12}>
                <Grid
                  container
                  spacing={1}
                  alignItems="center"
                  justifyContent="center"
                  sx={{ my: 2 }}

                >
                  <Grid item xs={3}>
                    <Typography sx={{ fontSize: '0.875rem' }}>
                      Amount met: $
                    </Typography>
                  </Grid>
                  <Grid item xs={3}>
                    <Controller
                      name="familyAmountMet"
                      // {...register("familyAmountMet")}
                      control={control}
                      render={({ field }) => (
                        <TextField
                          type="text"
                          size="small"
                          variant="standard"
                          {...field}
                          value={famAmount}
                          onChange={e => {
                            setValue('familyAmountMet', e.target.value)
                            setFamAmount(e.target.value)
                          }}
                          fullWidth
                        />
                      )}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>


            <Grid container>
              <Grid item xs={12}>
                <Grid
                  container
                  spacing={1}
                  alignItems="center"
                  justifyContent="center"
                  sx={{ my: 2 }}

                >
                  <Grid item xs={5.5}>
                    <Typography sx={{ fontSize: '0.875rem' }}>
                      *Is pre-authorization needed before treatment?
                    </Typography>
                  </Grid>

                  <Grid item xs={2} >
                    <div>
                      <input
                        type="radio"
                        name="preAuthorizationTreatment"
                        checked={pauthTreatment ? true : false}
                        onClick={(e) => {
                          setValue('preAuthorizationTreatment', true)
                          setPauthTreatment(true)

                        }}

                        style={{ marginLeft: "20px", marginTop: "12px" }}
                      />{" "}
                      Yes
                      <input
                        type="radio"
                        checked={pauthTreatment ? false : true}
                        onClick={(e) => {
                          setValue("preAuthorizationTreatment", false);
                          setPauthTreatment(false);
                        }}
                        style={{ marginLeft: "20px" }}
                      />{" "}
                      No
                    </div>

                  </Grid>

                  <Grid item xs={1}>
                    <Typography sx={{ fontSize: '0.875rem' }}>
                      Phone :
                    </Typography>
                  </Grid>
                  <Grid item xs={2} >
                    <InputMask
                      mask='+1 999-999-9999'
                      disabled={false}
                      value={cellPhone}
                      style={{ height: '30px' }}
                      onChange={e => {
                        setValue('preAuthorizationNumber', e.target.value)
                        setcellPhone(e.target.value)
                      }}
                    >
                      {() => <TextField id='outlined-basic' variant="standard" fullWidth size='small' />}
                    </InputMask>
                    {/* <Controller
                name="preAuthorizationNumber"
              
                control={control}
                render={({ field }) => (
                  <TextField
                 
                    size="small"
                    variant="standard"
                    {...field}
                    fullWidth
                    value={patientphone}
                    onChange={e => {
                      setValue('preAuthorizationNumber', e.target.value)
                      setpatientphone(e.target.value)
                    }}
                  />
                )}
              /> */}
                  </Grid>
                </Grid>
              </Grid>
            </Grid>

            <Grid container>
              <Grid item xs={12}>
                <Grid
                  container
                  spacing={1}
                  alignItems="center"
                  justifyContent="center"
                  sx={{ my: 2 }}

                >
                  {/* <Grid item xs={5}>
              <Typography
                sx={{
                  marginTop: "10px",
                  marginLeft: "70px",
                }}
              >
                Are dentist approve to perform services?
              </Typography>
            </Grid>
            <Grid item xs={2} sx={{ marginLeft: "-40px" }}>
              <div>
                <input
                  type="radio"
                  name="approvedDentist"
                  checked={apDentist ? true : false}
                  onClick={(e) => {
                    setValue('approvedDentist', true)
                    setApDentist(true)

                  }}

                  // {...register("heartProblems")}
                  style={{ marginLeft: "20px", marginTop: "12px" }}
                />{" "}
                Yes
                <input
                  type="radio"
                  checked={apDentist ? false : true}
                  onClick={(e) => {
                    setValue("approvedDentist", false);
                    setApDentist(false);
                  }}
                  style={{ marginLeft: "20px" }}
                />{" "}
                No
              </div>
            </Grid > */}
                  {/* <Grid item xs={1}></Grid> */}
                  <Grid item xs={2}>
                    <Typography sx={{ fontSize: '0.875rem' }}>
                      Approval
                    </Typography>
                  </Grid>
                  <Grid item xs={4}>
                    <Controller
                      name="approval"
                      // {...register("approval")}
                      control={control}
                      render={({ field }) => (
                        <TextField
                          type="text"
                          size="small"
                          variant="standard"
                          {...field}
                          value={approval}
                          onChange={e => {
                            setValue('approval', e.target.value)
                            setApproval(e.target.value)
                          }}

                          fullWidth
                        />
                      )}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>



            <Grid container>
              <Grid item xs={12}>
                <Grid
                  container
                  spacing={1}
                  alignItems="center"
                  justifyContent="center"
                  sx={{ my: 2 }}>
                  <Grid item xs={2}>
                    <Typography sx={{ fontSize: '0.975rem', textAlign: 'left', textDecoration: 'underline', fontWeight: 'bold' }}>
                      Date Range
                    </Typography>
                  </Grid>
                  <Grid item xs={1}>
                    <Typography sx={{ fontSize: '0.875rem' }}>
                      From
                    </Typography>
                  </Grid>
                  <Grid item xs={2} >
                    <Controller
                      name="rangeDateform"
                      control={control}
                      render={({ field }) => (
                        <TextField
                          type="date"
                          size="small"
                          variant="standard"
                          {...field}
                          fullWidth
                          value={rangeDateform}
                          onChange={e => {
                            setValue('rangeDateform', e.target.value)
                            setRangeDateform(e.target.value)
                          }}
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={1}>
                    <Typography sx={{ fontSize: '0.875rem' }}>
                      To:
                    </Typography>
                  </Grid>
                  <Grid item xs={2} >
                    <Controller
                      name="rangeDate"
                      // {...register("rangeDate")}
                      control={control}
                      render={({ field }) => (
                        <TextField
                          type="date"
                          size="small"
                          variant="standard"
                          {...field}
                          fullWidth
                          value={rangeDate}
                          onChange={e => {
                            setValue('rangeDate', e.target.value)
                            setRangeDate(e.target.value)
                          }}
                        />
                      )}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>

            <Grid container>
              <Grid item xs={12}>
                <Grid
                  container
                  spacing={2}
                  alignItems="center"
                  justifyContent="center"
                  sx={{ my: 2 }}>

                  <Grid item xs={3.5}>
                    <Typography sx={{ fontSize: '0.875rem' }}>
                      Estimated Allowable from Carrier:$
                    </Typography>
                  </Grid>
                  <Grid item xs={1.5}>
                    <Controller
                      name="estimatedAllowable"
                      // {...register("estimatedAllowable")}
                      control={control}
                      render={({ field }) => (
                        <TextField
                          type="text"
                          size="small"
                          variant="standard"
                          {...field}
                          value={estimatedAllowable}
                          onChange={e => {
                            setValue('estimatedAllowable', e.target.value)
                            setestimatedAllowable(e.target.value)
                          }}
                          fullWidth
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={4.3}>
                    <Typography sx={{ fontSize: '0.875rem' }}>
                      Estimated Total Patient Responsibility:$
                    </Typography>
                  </Grid>
                  <Grid item xs={1.5}>
                    <Controller
                      name="totalEstimated"
                      // {...register("totalEstimated")}
                      control={control}
                      render={({ field }) => (
                        <TextField
                          type="text"
                          size="small"
                          variant="standard"
                          {...field}
                          value={totalEstimated}
                          onChange={e => {
                            setValue('totalEstimated', e.target.value)
                            settotalEstimated(e.target.value)
                          }}
                          fullWidth
                        />
                      )}
                    />
                  </Grid>
                    <Grid item xs={1}></Grid>
               <Grid item xs={4}>
                <Typography
                sx={{
                  marginTop: "10px",
                  marginLeft: "20px",
                }}
              >
                Use a Medicare Approved Appliance
              </Typography>
              </Grid>
               <Grid item xs={3} >
                    <div>
                      <input
                        type="radio"
                        name="approvedAppliance"
                          checked={ApprovedAppliance === 'Yes'}
                        onClick={(e) => {
                               setValue('approvedAppliance', 'Yes');
                          setApprovedAppliance('Yes');
                          setErrorApprovedAppliance('');

                        }}

                        style={{ marginLeft: "20px", marginTop: "12px" }}
                      />{" "}
                      Yes
                      <input
                        type="radio"
                        name="approvedAppliance"
                      checked={ApprovedAppliance === 'No'}
                        onClick={(e) => {
                          setValue('approvedAppliance', 'No');
                          setApprovedAppliance('No');
                          setErrorApprovedAppliance('');
                        }}
                        style={{ marginLeft: "20px" }}
                      />{" "}
                      No/Optional

                       {(UserType === 'Back Office Admin' || UserType === 'Back Office User') && errorApprovedAppliance && (
      <div style={{ color: 'red', fontSize: '12px', marginTop: '5px' }}>
        {errorApprovedAppliance}
      </div>
    )}
                    </div>

                  </Grid>
                   <Grid item xs={4}></Grid>
                  {rights?.Auth_Comments && (

                    <Grid item xs={5} style={{ marginTop: "10px" }}>
                      <Typography sx={{ fontSize: '0.875rem' }}>
                        Comments
                      </Typography>
                      <Controller
                        name='rangecomments'
                        // {...register('rangecomments')}
                        control={control}
                        render={({ field }) => (
                          <TextareaAutosize
                            aria-label='minimum height'
                            minRows={2}
                            placeholder='Enter comments'
                            style={{
                              width: '100%',
                              borderRadius: '8px',
                              border: '2px solid #black',
                              height: '60px', // set a fixed height here

                            }}
                            {...field}
                            fullWidth
                            value={rangecomments || addNotes}
                            onChange={e => {
                              setValue('rangecomments', e.target.value)
                              setrangecomments(e.target.value)
                            }}
                          />
                        )}
                      />

                    </Grid>
                  )}
                  {rights?.Auth_backOffice_Comments && (
                    <Grid item xs={5} style={{ marginTop: "10px" }}>
                      <Typography sx={{ fontSize: '0.875rem' }}>
                        Back Office Comments
                      </Typography>
                      <Controller
                        name='backOffice'
                        // {...register('rangecomments')}
                        control={control}
                        render={({ field }) => (
                          <TextareaAutosize
                            aria-label='minimum height'
                            minRows={2}
                            placeholder='Enter comments'
                            style={{
                              width: '100%',
                              borderRadius: '8px',
                              border: '2px solid #black',
                              height: '60px', // set a fixed height here

                            }}
                            {...field}
                            fullWidth
                            value={backofficecomment}
                            onChange={e => {
                              setValue('backOffice', e.target.value)
                              setbackofficecomment(e.target.value)
                            }}
                          />
                        )}
                      />

                    </Grid>
                  )}

                  {/* </>)} */}

                </Grid>
              </Grid>
            </Grid>


            <Grid container sx={{ marginTop: "20px" }}>
              <Grid item xs={3}></Grid>
              <Grid item xs={3}>
                <Typography
                  sx={{
                    marginTop: "10px",
                    // marginLeft : "70px"
                  }}
                >
                  Cell referenced :
                </Typography>
              </Grid>
              <Grid item xs={3} sx={{ marginLeft: "-50px" }}>
                <Controller
                  name="cellReference"
                  // {...register("cellReference")}
                  control={control}
                  render={({ field }) => (
                    <TextField
                      type="text"
                      size="small"
                      variant="standard"
                      {...field}
                      value={cellReference}
                      onChange={e => {
                        setValue('cellReference', e.target.value)
                        setCellReference(e.target.value)
                      }}

                      fullWidth
                    />
                  )}
                />
              </Grid>
              <Grid item xs={4}></Grid>
            </Grid>

            <Grid container sx={{ marginTop: "20px" }}>
              <Grid item xs={1}></Grid>
              <Grid item xs={3}>
                <Typography
                  sx={{
                    marginTop: "10px",
                    // marginLeft : "70px"
                    fontWeight: 'bold'
                  }}
                >
                  Additional Notes :
                </Typography>
              </Grid>
              <Grid item xs={8}></Grid>
            </Grid>

            <Grid container sx={{ marginTop: "5px", marginBottom: "30px" }}>
              <Grid item xs={1}></Grid>
              <Grid item xs={10}>
                <Typography
                  sx={{
                    marginTop: "10px",
                    // marginLeft : "70px"
                  }}
                >
                  Insurance Disclaimer: "A quote of benefits and/or authorization
                  does not guarantee payment or verify eligibility. Payment or
                  benefits are subject to all terms,condition,limitation, and
                  exclusions of the member's contract at time of service."
                </Typography>
              </Grid>
              <Grid item xs={1}></Grid>
            </Grid>



          </Grid>
        )}


        <Grid container spacing={1}>
          <Grid item xs={12} lg={12} sm={12}>
            {props.ArchievedButton === true && rights?.Auth_Archived_Button && (
              <Grid item xs={12} lg={12} sm={12}>
                <Button
                  variant="gradient"
                  onClick={handleSubmit((data) => onSubmit(data, true))} //
                  style={{
                    marginTop: "0px",
                    marginBottom: "20px",
                    float: "right",
                    width: "200px",
                    height: "35px",
                    backgroundColor: "#57B9FF",
                    color: "white",
                    fontSize: "14px",
                  }}
                >
                  Archive
                </Button>
              </Grid>
            )}
            {rights.Auth_Save_Approve && (
              <Button
                onClick={handleSubmit((data) => onSubmit(data, false))} //
                variant="gradient"
                disabled={disable == true ? true : false}
                style={{
                  marginTop: "0px",
                  marginBottom: "20px",
                  float: "right",
                  width: "200px",
                  height: "35px",
                  backgroundColor: "#377562",
                  color: "white",
                  fontSize: "14px",
                }}
              >
                Save Approve
              </Button>
            )}
            {rights.Auth_Pending && (
              <Button
                onClick={handleSubmit(saveunappored)}
                variant="gradient"
                disabled={disable == true ? true : false}
                style={{
                  marginTop: "0px",
                  marginBottom: "20px",
                  float: "right",
                  // marginLeft: "-50px",
                  // marginRight: "60px",
                  width: "200px",
                  height: "35px",
                  marginRight: '30px',
                  backgroundColor: "#FFA500 ",
                  color: "white",
                  fontSize: "14px",
                }}
              >
                Save As Pending
              </Button>
            )}
            {props.Markaporoved == true && rights.Auth_Save_UnApprove && !props.UnapprovedButton ? (<>
              <Button
                className="Button"
                onClick={handleSubmit(Markunappored)}
                variant="gradient"
                disabled={disable == true ? true : false}
                style={{
                  marginTop: "0px",
                  marginBottom: "20px",
                  float: "right",
                  // marginLeft: "-50px",
                  // marginRight: "60px",
                  width: "220px",
                  height: "35px",
                  marginRight: '30px',
                  backgroundColor: "#A574FD",
                  color: "white",
                  fontSize: "14px",
                }}
              >
                Mark as Un Approved
              </Button>
            </>) : (<></>)}

          </Grid>

          {/* </>)} */}
        </Grid>
      </Container>

    </div >
  );
};

export default Prior_auth;
